<template>
<div>
    <v-toolbar dense class="mt-2" flat color="white" v-if="applicationInfo">
        
        <v-chip color="green" style="height: 22px" class="white--text" v-if="applicationInfo.isResolved && applicationInfo.isApproved">Approved</v-chip>
        <v-chip color="red" style="height: 22px" class="white--text" v-else-if="applicationInfo.isResolved && applicationInfo.isDenied">Denied</v-chip>
        <v-chip color="light-blue" style="height: 22px" class="white--text" v-else>Pending</v-chip>
        <v-toolbar-title>Order ID: {{ applicationInfo.id }}</v-toolbar-title>
        <!-- <v-flex xs3>
           
        </v-flex>
        <v-flex xs9>
            <h3 class="dark-grey--text px-2">
                <v-layout>
                    <span class="grey--text font-weight-light"> Order ID: {{ applicationInfo.id }}</span>
                </v-layout>
            </h3>
        </v-flex> -->

        <v-spacer></v-spacer>
        <v-btn @click="approveApplication" v-if="
          (applicationInfo && !applicationInfo.packagesIspId && applicationInfo.isContactVerified) ||
            (applicationInfo.ispVerified &&
              applicationInfo.ispAccepted &&
              !applicationInfo.isResolved &&
              (installNotRequired || (applicationInfo.isInstallVerified && applicationInfo.isDeviceVerified)) &&
              applicationInfo.locationId &&
              applicationInfo.isContactVerified &&
              (applicationInfo.packagesIspId == null ||
                applicationInfo.supplierOrganisationId != applicationInfo.packagesIsp.customerOrganisationId))
        " round color="primary">Approve</v-btn>
        <v-btn round disabled v-else-if="
          applicationInfo &&
            ((applicationInfo.ispVerified && applicationInfo.ispAccepted) || !applicationInfo.ispVerified) &&
            applicationInfo.serviceAccountId !== null &&
            applicationInfo.packagesIspId !== null &&
            !applicationInfo.isResolved &&
            (!applicationInfo.isInstallVerified ||
              !applicationInfo.isDeviceVerified ||
              !applicationInfo.isContactVerified) &&
            (applicationInfo.packagesIspId == null ||
              applicationInfo.supplierOrganisationId != applicationInfo.packagesIsp.customerOrganisationId)
        " class="white--text primary">Approve</v-btn>
        <v-btn round v-else-if="
          applicationInfo &&
            ((applicationInfo.ispVerified && applicationInfo.ispAccepted) || !applicationInfo.ispVerified) &&
            !applicationInfo.isResolved &&
            (applicationInfo.packagesIsp &&
              applicationInfo.supplierOrganisationId != applicationInfo.packagesIsp.customerOrganisationId)
        " disabled>Approve</v-btn>
        <v-btn round class="white--text" color="primary" v-else-if="
          applicationInfo &&
            !applicationInfo.isResolved &&
            applicationInfo.isInstallVerified &&
            applicationInfo.locationId &&
            applicationInfo.isDeviceVerified &&
            applicationInfo.isContactVerified &&
            applicationInfo.packagesIsp &&
            applicationInfo.supplierOrganisationId == applicationInfo.packagesIsp.customerOrganisationId &&
            applicationInfo.packagesIsp.datatillProductId &&
            datatillIntegration
        " @click="addCustomerModal = true">Approve</v-btn>
        <v-btn round class="white--text" color="primary" v-else-if="
          applicationInfo &&
            !applicationInfo.isResolved &&
            applicationInfo.isInstallVerified &&
            applicationInfo.isDeviceVerified &&
            applicationInfo.isContactVerified &&
            applicationInfo.packagesIsp &&
            applicationInfo.supplierOrganisationId == applicationInfo.packagesIsp.customerOrganisationId
        " @click="ispVerifyModal()">Approve</v-btn>
        <v-btn round disabled v-else-if="applicationInfo && !applicationInfo.isResolved">Approve</v-btn>
        <v-btn v-if="applicationInfo && !applicationInfo.isResolved" round color="red" class="white--text" @click="checkDenyPermissions()">Reject</v-btn>

        <!-- </v-layout> -->
    </v-toolbar>
    <v-divider></v-divider>

    <v-stepper v-model="stepperModel" class="elevation-0" alt-labels>
        <v-stepper-header>
            <v-stepper-step step="1" complete color="light-green">
                Order Received
            </v-stepper-step>

            <v-divider></v-divider>

            <v-stepper-step color="light-green" :rules="[() => contactVerified()]" :disabled="true" style="cursor: pointer; text-align: center" step="2" :complete="applicationInfo.isContactVerified">
                <v-layout justify-center wrap>
                    <v-flex xs12 class="text-xs-center">Contact(s) Verified</v-flex>
                    <v-flex xs12 class="text-xs-center">
                        <small v-if="!applicationInfo.primaryContactId">
                            <v-icon small color="orange">warning</v-icon> Create Primary Contact
                        </small>
                        <v-btn outline v-else-if="!applicationInfo.isContactVerified&&!verifyingContact" @click="verifyContact()" flat color="green" style="height: 25px">
                            <v-icon class="mr-1">check</v-icon> Verify
                        </v-btn>
                        <v-progress-circular v-else-if="verifyingContact" size="20" indeterminate color="primary"></v-progress-circular>
                    </v-flex>

                </v-layout>

            </v-stepper-step>

            <v-divider></v-divider>

            <v-stepper-step color="light-green" style="cursor: pointer" :complete="applicationInfo.isInstallVerified && applicationInfo.isDeviceVerified" step="3">
                <v-layout justify-center wrap>
                    <v-flex xs12 class="text-xs-center">Install Verified</v-flex>
                    <v-flex xs12 class="text-xs-center">
                        <v-btn @click="verifyInstallation()" v-if="!verifyingDevice&&!verifyingInstallation&&applicationInfo.isContactVerified&&(!applicationInfo.isInstallVerified||!applicationInfo.isDeviceVerified)&&device" flat color="green" outline style="height: 25px">
                            <v-icon class="mr-1">check</v-icon>Verify
                        </v-btn>
                        <small v-else-if="installNotRequired&&!applicationInfo.isInstallVerified">
                            Not needed to approve
                        </small>
                        <small v-else-if="applicationInfo.isContactVerified&&!applicationInfo.isInstallVerified&&!verifyingDevice&&!verifyingInstallation">
                            <v-icon small color="orange">warning</v-icon> Device Required
                        </small>
                        <v-progress-circular v-else-if="verifyingDevice||verifyingInstallation" size="20" indeterminate color="primary"></v-progress-circular>
                    </v-flex>
                </v-layout>
            </v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step step="4" color="light-green" :complete="applicationInfo.ispAccepted">

                <v-layout justify-center wrap>
                    <v-flex xs12 class="text-xs-center">ISP Approved</v-flex>
                    <v-flex xs12 class="text-xs-center">

                        <small v-if="applicationInfo.ispVerified && applicationInfo.ispAccepted && applicationInfo.ispVerifiedById != null">
                            Approved: {{ applicationInfo.ispVerifiedBy.name }} {{ applicationInfo.ispVerifiedBy.surname }} <br />
                            {{ formatDate(applicationInfo.ispVerifiedDate) }}
                        </small>
                        <small v-else-if="
          applicationInfo.ispVerified && !applicationInfo.ispAccepted && applicationInfo.ispVerifiedById != null
        ">
                            Rejected: {{ applicationInfo.ispVerifiedBy.name }} {{ applicationInfo.ispVerifiedBy.surname }} <br />
                            {{ formatDate(applicationInfo.ispVerifiedDate) }}
                        </small>
                    </v-flex>

                </v-layout>

            </v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step step="5" color="light-green" :complete="applicationInfo.isResolved && applicationInfo.isApproved" :rules="[
            () => {
              if (applicationInfo.isResolved && applicationInfo.isDenied) {
                return false;
              } else {
                return true;
              }
            },
          ]">
                FNO Approved
            </v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step step="6" color="light-green" :complete="applicationInfo.isResolved" style="cursor: pointer">
                <span @click="
              applicationInfo.serviceAccountId ? redirectToServiceAccount(applicationInfo.serviceAccountId) : null
            ">{{ applicationInfo.serviceAccount ? applicationInfo.serviceAccount.circuitNumber : "Complete" }}</span>
            </v-stepper-step>
        </v-stepper-header>
    </v-stepper>

    <v-card flat>

        <v-card-text style="margin: 0; padding: 0">
            <v-layout wrap>
                <v-flex xs12 sm8>
                    <v-layout justify-start wrap>
                        <v-flex xs12 md6 style="border-left: 1px solid lightgrey; border-right: 1px solid lightgrey; border-bottom: 1px solid lightgrey;">
                            <v-list subheader>
                                <v-subheader style="background: #f0f0f0"> Order Summary</v-subheader>
                                <span v-if="applicationInfo.deniedReason" style="padding: 5px; margin: 5px;"><b style="left: 5">Reason for Denial:</b>
                                    <p style="padding: 5px; margin: 5px; color: red">{{ applicationInfo.deniedReason }}</p>
                                </span>
                                <v-list-tile>
                                    <v-list-tile-action>
                                        <v-icon>event</v-icon>
                                    </v-list-tile-action>
                                    <v-list-tile-content>
                                        <v-list-tile-title style="fontSize: 14px">
                                            Date Submitted
                                        </v-list-tile-title>
                                    </v-list-tile-content>
                                    <v-list-tile-action style="fontSize: 14px">
                                        {{ formatDate(applicationInfo.createdAt) }}
                                    </v-list-tile-action>
                                </v-list-tile>

                                <v-list-tile>
                                    <v-list-tile-action>
                                        <v-icon>event</v-icon>
                                    </v-list-tile-action>
                                    <v-list-tile-content>
                                        <v-list-tile-title style="fontSize: 14px">
                                            Preferred Activation Date:
                                        </v-list-tile-title>
                                    </v-list-tile-content>
                                    <v-list-tile-action style="fontSize: 14px">
                                        <input v-if="installNotRequired && !applicationInfo.isResolved" type="date" :value="applicationInfo.activationDate" @change="setActivationDate($event)" title="Billing starts on this date when the order is approved" style="font-size: 14px; border-bottom: 1px solid #999">
                                        <span v-else>{{ applicationInfo.activationDate }}</span>
                                    </v-list-tile-action>
                                </v-list-tile>
                                <v-list-tile three-line v-if="applicationInfo.packagesIsp&&applicationInfo.packagesIsp.customerOrganisation" @click="routeToOrganisation(applicationInfo.packagesIsp.customerOrganisationId)">
                                    <v-list-tile-avatar>
                                        <v-img :src="applicationInfo.packagesIsp.customerOrganisation.logo" contain></v-img>
                                    </v-list-tile-avatar>
                                    <v-list-tile-content>
                                        <v-list-tile-title style="fontSize: 14px">
                                            {{ applicationInfo.packagesIsp.customerOrganisation.name }}
                                        </v-list-tile-title>
                                        <v-list-tile-sub-title style="fontSize: 14px">
                                            ISP
                                        </v-list-tile-sub-title>
                                    </v-list-tile-content>
                                    <v-list-tile-action style="fontSize: 14px">
                                        <!-- {{ applicationInfo.ispRecurringPriceVatInc | currency }}pm -->
                                    </v-list-tile-action>
                                </v-list-tile>

                                <v-list-tile three-line v-if="applicationInfo.packagesIspId !== null && applicationInfo.packagesIsp">
                                    <v-list-tile-action>
                                        <v-icon>bolt</v-icon>
                                    </v-list-tile-action>
                                    <v-list-tile-content>
                                        <v-list-tile-title style="fontSize: 14px">
                                            {{ applicationInfo.packagesIsp.name }}
                                        </v-list-tile-title>
                                        <v-list-tile-sub-title style="fontSize: 14px">
                                            {{ applicationInfo.ispOnceOffPriceVatInc | currency }} Once Off
                                        </v-list-tile-sub-title>
                                    </v-list-tile-content>
                                    <v-list-tile-action style="fontSize: 14px">
                                        {{ applicationInfo.ispRecurringPriceVatInc | currency }}pm
                                    </v-list-tile-action>
                                </v-list-tile>

                                <v-list-tile>
                                    <v-list-tile-action>
                                        <v-icon>paid</v-icon>
                                    </v-list-tile-action>
                                    <v-list-tile-content>
                                        <v-list-tile-title style="fontSize: 14px">
                                            Router Installation Fee:
                                        </v-list-tile-title>
                                    </v-list-tile-content>
                                    <v-list-tile-action style="fontSize: 14px">
                                        {{ applicationInfo.routerInstallationFee | currency }}
                                    </v-list-tile-action>
                                </v-list-tile>

                                <v-list-tile v-if="applicationInfo.isValidPromo !== null">
                                    <v-list-tile-content>
                                        <v-list-tile-title style="fontSize: 14px">
                                            Promotion Code:
                                        </v-list-tile-title>
                                        <v-list-tile-subtitle>
                                            <span v-if="applicationInfo && applicationInfo.promotion" class="grey--text font-weight-light">
                                                {{ applicationInfo.promotion.name }}
                                            </span>
                                            <span v-else-if="applicationInfo && applicationInfo.promoCode" class="grey--text font-weight-light">
                                                {{ applicationInfo.promoCode }}
                                            </span>
                                        </v-list-tile-subtitle>
                                    </v-list-tile-content>
                                    <v-list-tile-action style="fontSize: 14px">
                                        <v-chip small v-if="applicationInfo.isValidPromo == true" class="white--text" color="light-green">Valid</v-chip>
                                        <v-chip small v-else class="white--text" color="orange">Invalid</v-chip>
                                    </v-list-tile-action>
                                </v-list-tile>

                                <v-list-tile v-if="products.length > 0" @click="showProducts = true">
                                    <v-list-tile-action>
                                        <v-icon>paid</v-icon>
                                    </v-list-tile-action>
                                    <v-list-tile-content>
                                        <v-list-tile-title style="fontSize: 14px">
                                            Additional Products:
                                        </v-list-tile-title>
                                    </v-list-tile-content>
                                    <v-list-tile-action style="fontSize: 14px">
                                        <v-chip style="cursor: pointer" class="white--text" color="primary">{{ products.length }}</v-chip>
                                    </v-list-tile-action>
                                </v-list-tile>
                                <span v-if="applicationInfo.notes" style="padding: 5px; margin: 5px;"><b style="left: 5">Notes:</b>
                                    <p style="padding: 5px; margin: 5px">{{ applicationInfo.notes }}</p>
                                </span>
                            </v-list>
                        </v-flex>
                        <v-flex xs12 md6 style="border-left: 1px solid lightgrey; border-right: 1px solid lightgrey; border-bottom: 1px solid lightgrey; ">
                            <!-- <h3>
                        <v-icon v-if="!applicationInfo.isResolved && !applicationInfo.isContactVerified" color="orange">warning</v-icon>Contact Information
                    </h3> -->
                            <v-subheader style="background: #f0f0f0"> Contact Information</v-subheader>
                            <v-tabs grow v-model="showLocationContacts" v-if="locationContacts.length>0">
                                <v-tab>
                                    Order Contacts
                                </v-tab>
                                <v-tab>
                                    Existing Contacts <v-chip>{{locationContacts.length}}</v-chip>
                                </v-tab>
                            </v-tabs>
                            <v-list three-line v-if="showLocationContacts==0">
                                <v-list-tile>
                                    <v-list-tile-action>
                                        <v-tooltip top>
                                            <template v-slot:activator="{ on }">
                                                <v-avatar size="32px" v-on="on" color="blue" class="white--text">1st</v-avatar>
                                            </template>
                                            <span>Primary Contact</span>
                                        </v-tooltip>
                                    </v-list-tile-action>
                                    <v-list-tile-content>
                                        <v-list-tile-title style="fontSize: 14px">
                                            {{ applicationInfo.primaryContactTitle }}
                                            {{ applicationInfo.primaryContactFirstname }}
                                            {{ applicationInfo.primaryContactLastname }}
                                        </v-list-tile-title>
                                        <v-list-tile-sub-title style="fontSize: 12px">
                                            <v-icon small color="grey">smartphone</v-icon> {{ applicationInfo.primaryContactMobileNumber }}
                                        </v-list-tile-sub-title>
                                        <v-list-tile-sub-title style="fontSize: 12px">
                                            <v-icon small color="grey">email</v-icon> {{ applicationInfo.primaryContactEmailAddress }}
                                        </v-list-tile-sub-title>
                                    </v-list-tile-content>
                                    <v-list-tile-action>
                                        <v-layout justify-center wrap>
                                            <v-btn small icon class="ma-1" v-if="applicationInfo.primaryContactId === null&&!creatingPrimaryContact" round color="primary" @click="editContact('Primary')">
                                                <v-icon small>edit</v-icon>
                                            </v-btn>
                                            <v-btn small class="ma-1" v-if="
                                        !creatingPrimaryContact &&
                                          applicationInfo.primaryContactId === null &&
                                          !linkedPrimaryContacts.length > 0
                                      " round icon color="primary" @click="addContact('Primary')">
                                                <v-icon small>person_add</v-icon>
                                            </v-btn>
                                            <v-progress-circular v-if="creatingPrimaryContact" size="20" indeterminate color="primary"></v-progress-circular>
                                            <v-btn small v-if="
                                        applicationInfo.primaryContactId === null && linkedPrimaryContacts.length > 0
                                      " icon class="white--text ma-1" round color="orange" @click="similarContactsModalPrimary = true">
                                                <v-icon small color="white">priority_high</v-icon>
                                            </v-btn>
                                            <v-icon v-if="applicationInfo.primaryContactId !== null" color="green">check_circle_outline</v-icon>
                                        </v-layout>
                                    </v-list-tile-action>
                                </v-list-tile>

                                <v-list-tile v-if="applicationInfo.secondaryContactFirstname !== null">
                                    <v-list-tile-action>
                                        <v-tooltip top>
                                            <template v-slot:activator="{ on }">
                                                <v-avatar size="32px" v-on="on" color="blue" class="white--text">2nd</v-avatar>
                                            </template>
                                            <span>Secondary Contact</span>
                                        </v-tooltip>
                                    </v-list-tile-action>
                                    <v-list-tile-content>
                                        <v-list-tile-title style="fontSize: 14px">
                                            {{ applicationInfo.secondaryContactTitle }}
                                            {{ applicationInfo.secondaryContactFirstname }}
                                            {{ applicationInfo.secondaryContactLastname }}
                                        </v-list-tile-title>
                                        <v-list-tile-sub-title style="fontSize: 12px">
                                            <v-icon small color="grey">smartphone</v-icon> {{ applicationInfo.secondaryContactMobileNumber }}
                                        </v-list-tile-sub-title>
                                        <v-list-tile-sub-title style="fontSize: 12px">
                                            <v-icon small color="grey">email</v-icon> {{ applicationInfo.secondaryContactEmailAddress }}
                                        </v-list-tile-sub-title>
                                    </v-list-tile-content>
                                    <v-list-tile-action>
                                        <v-layout wrap justify-center>
                                            <v-btn small class="ma-1" v-if="applicationInfo.secondaryContactId === null&&!creatingSecondaryContact" round icon color="primary" @click="editContact('Secondary')">
                                                <v-icon small>edit</v-icon>
                                            </v-btn>
                                            <v-btn small class="ma-1" v-if="
                                        !creatingSecondaryContact &&
                                          applicationInfo.secondaryContactId === null &&
                                          !linkedSecondaryContacts.length > 0
                                      " round icon color="primary" @click="addContact('Secondary')">
                                                <v-icon small>person_add</v-icon>
                                            </v-btn>
                                            <v-progress-circular v-if="creatingSecondaryContact" size="20" indeterminate color="primary"></v-progress-circular>
                                            <v-btn small v-if="
                                        applicationInfo.secondaryContactId === null &&
                                          linkedSecondaryContacts.length > 0
                                      " class="white--text ma-1" round color="orange" @click="similarContactsModalSecondary = true" icon>
                                                <v-icon small color="white">priority_high</v-icon>
                                            </v-btn>
                                            <v-icon v-if="applicationInfo.secondaryContactId !== null" color="green">check_circle_outline</v-icon>
                                        </v-layout>
                                    </v-list-tile-action>
                                </v-list-tile>

                                <v-list-tile v-if="applicationInfo.billingContactFirstname !== null">
                                    <v-list-tile-action>
                                        <v-tooltip top>
                                            <template v-slot:activator="{ on }">
                                                <v-avatar size="32px" v-on="on" color="blue">
                                                    <v-icon color="white">attach_money</v-icon>
                                                </v-avatar>
                                            </template>
                                            <span>Billing Contact</span>
                                        </v-tooltip>
                                    </v-list-tile-action>

                                    <v-list-tile-content>
                                        <v-list-tile-title style="fontSize: 14px">
                                            {{ applicationInfo.billingContactTitle }}
                                            {{ applicationInfo.billingContactFirstname }}
                                            {{ applicationInfo.billingContactLastname }}
                                        </v-list-tile-title>
                                        <v-list-tile-sub-title style="fontSize: 12px">
                                            <v-icon small color="grey">smartphone</v-icon> {{ applicationInfo.billingContactMobileNumber }}
                                        </v-list-tile-sub-title>
                                        <v-list-tile-sub-title style="fontSize: 12px">
                                            <v-icon small color="grey">email</v-icon> {{ applicationInfo.billingContactEmailAddress }}
                                        </v-list-tile-sub-title>
                                    </v-list-tile-content>
                                    <v-list-tile-action>
                                        <v-layout row wrap justify-center>
                                            <v-btn class="ma-1" small v-if="applicationInfo.billingContactId === null&&!creatingBillingContact" round icon color="primary" @click="editContact('Billing')">
                                                <v-icon small>edit</v-icon>
                                            </v-btn>
                                            <v-btn small class="ma-1" v-if="
                                        !creatingBillingContact &&
                                          applicationInfo.billingContactId === null &&
                                          !linkedBillingContacts.length > 0
                                      " round icon color="primary" @click="addContact('Billing')">
                                                <v-icon small>person_add</v-icon>
                                            </v-btn>
                                            <v-progress-circular v-if="creatingBillingContact" size="20" indeterminate color="primary"></v-progress-circular>
                                            <v-btn small v-if="
                                        applicationInfo.billingContactId === null && linkedBillingContacts.length > 0
                                      " class="white--text ma-1" round color="orange" @click="similarContactsModalBilling = true" icon>
                                                <v-icon small color="white">priority_high</v-icon>
                                            </v-btn>
                                            <v-icon v-if="applicationInfo.billingContactId !== null" color="green">check_circle_outline</v-icon>
                                        </v-layout>
                                    </v-list-tile-action>
                                </v-list-tile>
                            </v-list>

                            <v-list v-else three-line>
                                <v-list-tile v-for="contact in locationContacts" :key="contact.id">
                                    <v-list-tile-content>
                                        <v-list-tile-title style="fontSize: 14px">
                                            {{ contact.contact.name }}
                                            {{ contact.contact.surname }}
                                        </v-list-tile-title>
                                        <v-list-tile-sub-title style="fontSize: 14px">
                                            {{contact.contactType.name}} Contact
                                        </v-list-tile-sub-title>
                                        <v-list-tile-sub-title style="fontSize: 14px">
                                            Created {{ formatDate(contact.createdAt)}}
                                        </v-list-tile-sub-title>
                                    </v-list-tile-content>
                                    <v-list-tile-action>
                                        <v-btn icon small color="red" @click="removeContact(contact)">
                                            <v-icon small color="white">delete</v-icon>
                                        </v-btn>
                                    </v-list-tile-action>
                                </v-list-tile>
                            </v-list>

                        </v-flex>

                        <v-flex xs12 md6 style="border-left: 1px solid lightgrey; border-right: 1px solid lightgrey; border-bottom: 1px solid lightgrey; ">

                            <v-list subheader>
                                <v-subheader style="background: #f0f0f0">Location Information</v-subheader>
                                <v-list-tile>
                                    <v-list-tile-action v-if="!editLocation">
                                        <v-icon v-if="applicationInfo.location">location_on</v-icon>
                                        <v-icon color="warning" v-else>warning</v-icon>
                                    </v-list-tile-action>
                                    <v-list-tile-content v-if="!editLocation">
                                        <v-list-tile-title style="fontSize: 14px" v-if="applicationInfo.location">
                                            {{ applicationInfo.location.locationDescription }}
                                        </v-list-tile-title>
                                        <v-list-tile-title style="fontSize: 14px" v-else>
                                            {{ formattedAddress }}
                                        </v-list-tile-title>
                                        <v-list-tile-subtitle style="fontSize: 14px">
                                            <span class="grey--text font-weight-light" v-if="applicationInfo.locationId">{{
                applicationInfo.location.locationNetwork.name
              }}</span>
                                            <span class="grey--text font-weight-light" v-else-if="applicationInfo.locationNetwork">{{
                applicationInfo.locationNetwork.name
              }}</span>
                                            <v-chip style="height: 18px" class="white--text" color="green" v-if="applicationInfo.location&&applicationInfo.location.locationNetwork.networkStatus=='Live'">Live</v-chip>
                                            <v-chip style="height: 18px" class="white--text" color="blue" v-if="applicationInfo.location&&applicationInfo.location.locationNetwork.networkStatus=='In Progress'">In Progress</v-chip>
                                            <v-chip style="height: 18px" class="white--text" color="orange" v-if="applicationInfo.location&&applicationInfo.location.locationNetwork.networkStatus=='Planned'">Planned</v-chip>
                                        </v-list-tile-subtitle>
                                    </v-list-tile-content>
                                   <v-list-tile-content style="width:90%" v-else>
                                         <v-autocomplete ref="location" 
                               
                                style="font-size: 12px;width:100%"
                                clearable v-on:blur="$refs['location'].blur()" 
                                v-model="applicationInfo.location" return-object :items="locations" item-text="locationDescription" item-value="id" 
                                :loading="isLoading" placeholder="Search for Location" :search-input.sync="searchLocation" 
                                color="black" 
                                hide-no-data hide-selected></v-autocomplete>
                                    </v-list-tile-content>
                                    <v-list-tile-action v-if="!editLocation">
                                        <v-layout justify-center>
                                            <v-icon v-if="!applicationInfo.location" @click="attachLocationModal=true">edit</v-icon>
                                            <v-icon v-else @click="editLocation=true">edit</v-icon>

                                            <v-icon v-if="applicationInfo.location" @click="goToLocation()">launch</v-icon>
                                        </v-layout>
                                    </v-list-tile-action>
                                     <v-list-tile-action v-else>
                                        <v-btn icon @click="updateApplication({id: applicationInfo.id, locationId: applicationInfo.location?applicationInfo.location.id:null}), editLocation= false">
                                            <v-icon color="primary">check</v-icon>
                                        </v-btn>
                                    </v-list-tile-action>
                                </v-list-tile>
                                <v-subheader style="background: #f0f0f0">Installed Equipment</v-subheader>
                                <v-layout align-center>
                                    <v-flex xs6>
                                        <v-list-tile v-if="applicationInfo.location">
                                            <v-list-tile-action>
                                                <v-icon>cable</v-icon>
                                            </v-list-tile-action>
                                            <v-list-tile-content>
                                                <v-list-tile-title style="fontSize: 14px">
                                                    Fibre:
                                                </v-list-tile-title>
                                            </v-list-tile-content>
                                            <v-list-tile-action>
                                                <v-icon color="green" v-if="applicationInfo.location.fibrePulled">check_circle_outline</v-icon>
                                                <v-icon color="red" v-else>not_interested</v-icon>
                                            </v-list-tile-action>
                                        </v-list-tile>
                                    </v-flex>
                                    <v-flex xs6>
                                        <v-list-tile v-if="applicationInfo.location">
                                            <v-list-tile-action>
                                                <v-icon>router</v-icon>
                                            </v-list-tile-action>
                                            <v-list-tile-content>
                                                <v-list-tile-title style="fontSize: 14px">
                                                    Device:
                                                </v-list-tile-title>
                                            </v-list-tile-content>
                                            <v-list-tile-action>
                                                <v-icon color="green" v-if="applicationInfo.location.equipmentInstalled && device">check_circle_outline</v-icon>
                                                <v-icon color="red" v-else>not_interested</v-icon>
                                            </v-list-tile-action>
                                        </v-list-tile>
                                    </v-flex>
                                    <!-- <v-flex xs2 class='text-xs-center'>
                                    <v-btn flat v-if="!applicationInfo.location.fibrePulled && !applicationInfo.location.equipmentInstalled" color="primary" class="white--text" @click="createTicket('Full')"><v-icon>add_task</v-icon></v-btn>
                        <v-btn flat v-else-if="!applicationInfo.location.fibrePulled" color="primary" class="white--text" @click="createTicket('Passive')"><v-icon>add_task</v-icon></v-btn>
                        <v-btn flat v-else-if="!applicationInfo.location.equipmentInstalled" color="primary" class="white--text" @click="createTicket('Active')"><v-icon>add_task</v-icon></v-btn>
                        <v-btn flat v-else-if="
                      (applicationInfo && !applicationInfo.isInstallVerified) || !applicationInfo.isDeviceVerified
                    " color="primary" class="white--text" @click="createTicket('Active')"><v-icon>add_task</v-icon></v-btn>
                            </v-flex> -->
                                </v-layout>
                                <v-list-tile v-if="device" @click="routeToDevice(device.id)">
                                    <v-list-tile-action>
                                        <v-icon>router</v-icon>
                                    </v-list-tile-action>
                                    <v-list-tile-content>
                                        <v-list-tile-title style="fontSize: 14px">
                                            {{ device.ponMac }}
                                        </v-list-tile-title>
                                        <v-list-tile-sub-title style="fontSize: 14px">
                                            {{ device.deviceMakeModel.deviceMake.name }}
                                            {{ device.deviceMakeModel.name }}
                                        </v-list-tile-sub-title>
                                    </v-list-tile-content>
                                </v-list-tile>

                                <v-subheader v-if="existingServiceAccounts.length>0" style="background: #f0f0f0">Current Service Accounts</v-subheader>

                                <v-list-tile v-for="serviceAccount in existingServiceAccounts" :key="serviceAccount.id" @click="routeToServiceAccount(serviceAccount.id)">
                                    <v-list-tile-action>
                                        <v-icon>miscellaneous_services</v-icon>
                                    </v-list-tile-action>
                                    <v-list-tile-content>
                                        <v-list-tile-title style="fontSize: 14px">
                                            {{ serviceAccount.circuitNumber }}
                                        </v-list-tile-title>
                                        <v-list-tile-sub-title style="fontSize: 14px">
                                            {{ serviceAccount.customerOrganisation.name }}
                                        </v-list-tile-sub-title>
                                    </v-list-tile-content>
                                    <v-list-tile-action>
                                        <v-chip style="height: 18px" outline v-if="serviceAccount.fnoActivationDate!==null&&new Date(serviceAccount.fnoActivationDate)<new Date()&&serviceAccount.isSuspended&&serviceAccount.isActive" class="white--text" color="orange">Suspended</v-chip>
                                        <v-chip style="height: 18px" outline v-else-if="serviceAccount.fnoActivationDate!==null&&new Date(serviceAccount.fnoActivationDate)<new Date()&&(new Date(serviceAccount.fnoDeactivationDate)>new Date()||serviceAccount.fnoDeactivationDate==null)" class="white--text" color="light-green">Active</v-chip>
                                        <v-chip style="height: 18px" outline v-else-if="serviceAccount.fnoActivationDate!==null&&serviceAccount.fnoDeactivationDate!=null&&(new Date(serviceAccount.fnoDeactivationDate)<new Date())" class="white--text" color="red">Inactive</v-chip>
                                        <v-chip style="height: 18px" outline v-else-if="serviceAccount.fnoActivationDate==null||new Date(serviceAccount.fnoActivationDate)>new Date()" class="white--text" color="blue">Pending</v-chip>
                                    </v-list-tile-action>
                                </v-list-tile>

                            </v-list>
                        </v-flex>

                        <v-flex xs12 md6 style="border-left: 1px solid lightgrey; border-right: 1px solid lightgrey; border-bottom: 1px solid lightgrey; " :key="ticketKey">
                            <v-list subheader>
                                <v-subheader style="background: #f0f0f0">Documents</v-subheader>
                                <v-list-tile>
                                    <v-list-tile-action>
                                        <v-icon>description</v-icon>
                                    </v-list-tile-action>
                                    <v-list-tile-content>
                                        <v-list-tile-title style=" align-text: center;cursor: pointer" v-if="documents.length>0" @click="documentsModal=true">
                                            <v-chip style="height: 20px">{{documents.length}}</v-chip> Document(s)
                                        </v-list-tile-title>
                                        <v-list-tile-title v-else>
                                            No documents
                                        </v-list-tile-title>
                                    </v-list-tile-content>
                                    <v-list-tile-action>

                                        <div :class="['dropZone', dragging ? 'dropZone-over' : '']" @dragenter="dragging = true" @dragleave="dragging = false">
                                            <div class="dropZone-info" @drag="onChange">
                                                <span class="dropZone-title">Drop file or click to upload</span>
                                            </div>
                                            <input type="file" @change="onChange">
                                        </div>

                                    </v-list-tile-action>
                                </v-list-tile>

                                <v-subheader :key="ticketKey" style="background: #f0f0f0">Tickets <v-chip>{{ tickets.length }}</v-chip>
                                    <v-spacer></v-spacer>
                                    <v-btn icon color="primary" @click="createTicket('')"><v-icon color="white">add</v-icon></v-btn>
                                    <v-btn icon color="primary" @click="fetchTickets()"><v-icon color="white">refresh</v-icon></v-btn>
                                </v-subheader>
                                <v-data-table :rows-per-page-items="5" :key="ticketKey" :items="tickets" hide-headers style="cursor: pointer">
                                    <template v-slot:items="props">
                                        <td class="text-xs-center" @click="routeToTicketSummary(props.item.id)">
                                            {{ props.item.id }}
                                        </td>

                                        <td class="text-xs-center" @click="routeToTicketSummary(props.item.id)">
                                            <h3 class="grey--text">
                                                <v-chip small :class="`${props.item.currentStatus.replace(/\s/g, '').toLowerCase()} white--text`">{{ props.item.currentStatus }}</v-chip>
                                            </h3>
                                        </td>
                                        <td class="text-xs-center" @click="routeToTicketSummary(props.item.id)">
                                            {{ props.item.ticketCategoryItem.name }}
                                        </td>
                                        <td class="text-xs-center" @click="routeToTicketSummary(props.item.id)">
                                            {{ formatDate(props.item.dueDate) }}
                                        </td>
                                    </template>
                                </v-data-table>
                            </v-list>
                        </v-flex>
                    </v-layout>
                </v-flex>
                <v-flex xs12 sm4>
                    <v-subheader style="background: #f0f0f0">Comments</v-subheader>
                    <v-layout align-center justify-center wrap class="ma-2">
                        <v-flex xs9>

                            <at-ta :members="members">
                                <v-textarea class="my-0 py-0" auto-grow rows="1" outline row-height="10" v-model="comment"></v-textarea>
                            </at-ta>
                        </v-flex>
                        <v-flex xs3 class="text-xs-left pl-3">
                            <v-btn class="ma-0 pa-0" icon @click="addApplicationComment(comment)">
                                <v-icon>send</v-icon>
                            </v-btn>
                            <v-checkbox class="ma-0 pa-0" label="Internal" v-model="internal"></v-checkbox>
                        </v-flex>
                    </v-layout>
                    <div style="overflow-y: auto; max-height: 50vh;">
                        <v-layout v-for="item in commentArray" :key="item.id" justify-start align-center style="border-bottom: 1px solid lightgrey">
                            <v-flex xs3 class="text-xs-left ml-1">
                                <b>{{ item.commentedByName
                            }} {{ item.commentedBySurname}}</b> <br>
                                <small>{{item.organisation.name}}</small> <br />
                                <v-chip style="height: 20px" outline v-if="item.isInternal" color="blue">Internal
                                </v-chip> <br v-if="item.isInternal" />
                                <span style="color: grey; font-size: 10px">{{ formatDateTime(item.createdAt) }}</span>
                            </v-flex>
                            <v-flex class="text-xs-left pa-2" xs8>

                                <span class="darkgrey--text text-xs-left" v-html="item.comment"></span>
                            </v-flex>
                        </v-layout>
                    </div>
                </v-flex>
            </v-layout>

        </v-card-text>

    </v-card>

    <v-dialog v-model="deniedReasonModal" max-width="750px">
        <v-card flat color="white">
            <v-toolbar flat color="primary">
                <h3 class="headline white--text">
                    Please provide a reason for denying the application
                </h3>
            </v-toolbar>
            <v-card-text>
                <v-textarea label="Reason for Rejection" v-model="deniedReason"></v-textarea>
            </v-card-text>
            <v-card-actions>
                <v-layout justify-center>
                    <v-btn round color="primary" class="white--text" @click="deniedReasonModal = false">Cancel</v-btn>
                    <v-btn v-if="deniedReason !== '' && deniedReason" round color="primary" class="white--text" @click="rejectApplication">Reject Application</v-btn>
                </v-layout>
            </v-card-actions>
        </v-card>
    </v-dialog>

    <!-- Similar Contacts Modal -->
    <v-dialog v-model="similarContactsModalPrimary" max-width="750px">
        <v-card>
            <v-toolbar flat color="primary">
                <h3 class="headline white--text">SIMILAR CONTACTS</h3>
                <v-spacer></v-spacer>
                <!-- <v-btn @click="addContact('Primary')" class='white--text' flat><v-icon class='white--text' >add</v-icon> Create New Contact</v-btn> -->
            </v-toolbar>
            <v-card-text>
                <v-flex xs12 sm6 md6 lg6 v-for="person in linkedPrimaryContacts" :key="person.name">
                    <v-card hover class="text-xs-center mb-2 mx-2">
                        <div class="subheading text-uppercase">{{ person.name }} {{ person.surname }}</div>
                        <v-responsive></v-responsive>
                        <v-card-text>
                            <v-layout>
                                <v-flex xs2 class="text-xs-right">
                                    <v-icon small color="grey">smartphone</v-icon>
                                </v-flex>
                                <v-flex xs8 justify-left>
                                    <div class="grey--text">{{ person.mobileNumber }}</div>
                                </v-flex>
                            </v-layout>
                            <v-layout>
                                <v-flex xs2 class="text-xs-right">
                                    <v-icon small color="grey">email</v-icon>
                                </v-flex>
                                <v-flex xs8 justify-left>
                                    <div class="grey--text">{{ person.emailAddress }}</div>
                                </v-flex>
                            </v-layout>
                            <v-layout>
                                <v-flex xs2 class="text-xs-right">
                                    <v-icon small color="grey">perm_identity</v-icon>
                                </v-flex>
                                <v-flex xs8 justify-left>
                                    <div class="grey--text">{{ person.idNumber }}</div>
                                </v-flex>
                            </v-layout>
                        </v-card-text>
                        <v-card-actions class="justify-center layout px-0">
                            <v-btn color="light-blue white--text" round @click="mergePrimaryContact(person)">
                                <v-icon small>call_merge</v-icon>Merge
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-flex>
            </v-card-text>
            <v-card-actions>
                <v-layout justify-center>
                    <v-btn round color="primary" @click="similarContactsModalPrimary = false">Cancel</v-btn>
                </v-layout>
            </v-card-actions>
        </v-card>
    </v-dialog>

    <v-dialog persistent v-model="attachLocationModal" max-width="1000px">
        <v-card>
            <v-toolbar flat color="primary">
                <h3 class="headline white--text">Attach Location</h3>
                <v-spacer></v-spacer>
                <v-btn flat color="white" @click="attachLocationModal=false">X</v-btn>
            </v-toolbar>
            <v-card-text>
                <v-checkbox label="Attach existing location" v-model="attachExistingLocation"></v-checkbox>
                <v-layout v-if="attachExistingLocation">
                    <v-spacer></v-spacer>
                    <v-flex xs6 mx-2>
                        <v-text-field label="Search" v-model="search" clearable append-icon="search" v-on:keyup.enter="
                        $router.push({
                            name: $route.name,
                            query: {
                            offset: $route.query.offset,
                            records: $route.query.records,
                            search: search,
                            },
                        })
                        "></v-text-field>
                    </v-flex>
                </v-layout>
                <v-layout justify-center v-if="attachExistingLocation">
                    <v-data-table :items="filteredLocations" :headers="locationHeaders" hide-actions>
                        <template v-slot:items="props">
                            <td class="text-xs-center">
                                <v-icon @click="attachExisting(props.item.id)" color="primary">add_circle_outline</v-icon>
                            </td>
                            <td class="text-xs-center">{{ props.item.unitNo }}</td>
                            <td class="text-xs-center">{{ props.item.erfNo }}</td>
                            <td class="text-xs-center">{{ props.item.otherNo }}</td>
                            <td class="text-xs-center">
                                {{ props.item.complexStreetName }}
                            </td>
                            <td class="text-xs-center" v-if="props.item.locationNetworkSubComplexId !== null">
                                {{ props.item.locationNetworkSubComplex.subcomplexName }}
                            </td>
                            <td v-else></td>
                            <td class="text-xs-center">
                                {{ props.item.locationNetwork.name }}
                            </td>
                        </template>
                    </v-data-table>
                </v-layout>
                <v-layout v-if="attachExistingLocation" justify-center>
                    <div class="text-xs-center pt-2 white" :key="$route.query.offset">
                        <v-pagination v-model="page" :length="Math.ceil(locationLength / $route.query.records)" :total-visible="7"></v-pagination>
                    </div>
                </v-layout>
                <v-container v-if="!attachExistingLocation" grid-list-xs>
                    <v-layout wrap>
                        <v-flex xs12 sm6 md4>
                            <v-autocomplete clearable hide-no-data flat color="primary" :items="locationNetworks" item-text="name" item-value="id" label="*Select an associated Network" v-model="applicationInfo.locationNetworkId">
                            </v-autocomplete>
                        </v-flex>
                        <v-flex xs12 sm6 md4>
                            <v-autocomplete clearable hide-no-data flat color="primary" :items="subComplexes" item-text="subComplexName" item-value="id" label="Select an associated Sub Complex" v-model="applicationInfo.locationNetworkSubComplexId">
                            </v-autocomplete>
                        </v-flex>
                        <v-flex xs12 sm6 md4>
                            <v-autocomplete clearable hide-no-data flat color="primary" :items="locationTypes" item-text="name" item-value="id" v-model="applicationInfo.locationTypeId" label="*Location Type" persistent-hint>
                            </v-autocomplete>
                        </v-flex>
                        <v-flex xs12 sm6 md4>
                            <v-text-field v-model="applicationInfo.erfNo" label="Erf No" type="number" persistent-hint></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm6 md4>
                            <v-text-field v-model="applicationInfo.unitNumber" label="*Unit No" required persistent-hint></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm6 md4>
                            <v-text-field v-model="applicationInfo.otherNo" label="Other No" persistent-hint></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm6 md4>
                            <v-text-field v-model="applicationInfo.floorNo" label="Floor No" type="number" persistent-hint></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm6 md4>
                            <v-text-field v-model="applicationInfo.streetName" label="Complex Street Name" persistent-hint></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm6 md4>
                            <v-text-field v-model="applicationInfo.complexName" label="Complex Name" required persistent-hint></v-text-field>
                        </v-flex>
                    </v-layout>
                </v-container>
                <v-layout justify-center v-if="!attachExistingLocation">
                    <v-btn round color="primary" v-if="applicationInfo.locationTypeId" @click="createNewLocation()">Create New Location</v-btn>
                    <v-btn round color="primary" v-else disabled @click="createNewLocation()">Create New Location</v-btn>
                </v-layout>
            </v-card-text>
        </v-card>
    </v-dialog>

    <!-- Similar Contacts Modal -->
    <v-dialog v-model="similarContactsModalSecondary" max-width="750px">
        <v-card>
            <v-toolbar flat color="primary">
                <h3 class="headline white--text">SIMILAR CONTACTS</h3>
                <v-spacer></v-spacer>
                <!-- <v-btn @click="addContact('Primary')" class='white--text' flat><v-icon class='white--text' >add</v-icon> Create New Contact</v-btn> -->
            </v-toolbar>
            <v-card-text>
                <v-flex xs12 sm6 md6 lg6 v-for="person in linkedSecondaryContacts" :key="person.name">
                    <v-card hover class="text-xs-center mb-2 mx-2">
                        <div class="subheading text-uppercase">{{ person.name }} {{ person.surname }}</div>
                        <v-responsive></v-responsive>
                        <v-card-text>
                            <v-layout>
                                <v-flex xs2 class="text-xs-right">
                                    <v-icon small color="grey">smartphone</v-icon>
                                </v-flex>
                                <v-flex xs8 justify-left>
                                    <div class="grey--text">{{ person.mobileNumber }}</div>
                                </v-flex>
                            </v-layout>
                            <v-layout>
                                <v-flex xs2 class="text-xs-right">
                                    <v-icon small color="grey">email</v-icon>
                                </v-flex>
                                <v-flex xs8 justify-left>
                                    <div class="grey--text">{{ person.emailAddress }}</div>
                                </v-flex>
                            </v-layout>
                            <v-layout>
                                <v-flex xs2 class="text-xs-right">
                                    <v-icon small color="grey">perm_identity</v-icon>
                                </v-flex>
                                <v-flex xs8 justify-left>
                                    <div class="grey--text">{{ person.idNumber }}</div>
                                </v-flex>
                            </v-layout>
                        </v-card-text>
                        <v-card-actions class="justify-center layout px-0">
                            <v-btn color="light-blue white--text" round @click="mergeSecondaryContact(person)">
                                <v-icon small>call_merge</v-icon>Merge
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-flex>
            </v-card-text>
            <v-card-actions>
                <v-layout justify-center>
                    <v-btn round color="primary" @click="similarContactsModalSecondary = false">Cancel</v-btn>
                </v-layout>
            </v-card-actions>
        </v-card>
    </v-dialog>

    <!-- Similar Contacts Modal -->
    <v-dialog v-model="similarContactsModalBilling" max-width="750px">
        <v-card>
            <v-toolbar flat color="primary">
                <h3 class="headline white--text">SIMILAR CONTACTS</h3>
                <v-spacer></v-spacer>
                <!-- <v-btn @click="addContact('Primary')" class='white--text' flat><v-icon class='white--text' >add</v-icon> Create New Contact</v-btn> -->
            </v-toolbar>
            <v-card-text>
                <v-flex xs12 sm6 md6 lg6 v-for="person in linkedBillingContacts" :key="person.name">
                    <v-card hover class="text-xs-center mb-2 mx-2">
                        <div class="subheading text-uppercase">{{ person.name }} {{ person.surname }}</div>
                        <v-responsive></v-responsive>
                        <v-card-text>
                            <v-layout>
                                <v-flex xs2 class="text-xs-right">
                                    <v-icon small color="grey">smartphone</v-icon>
                                </v-flex>
                                <v-flex xs8 justify-left>
                                    <div class="grey--text">{{ person.mobileNumber }}</div>
                                </v-flex>
                            </v-layout>
                            <v-layout>
                                <v-flex xs2 class="text-xs-right">
                                    <v-icon small color="grey">email</v-icon>
                                </v-flex>
                                <v-flex xs8 justify-left>
                                    <div class="grey--text">{{ person.emailAddress }}</div>
                                </v-flex>
                            </v-layout>
                            <v-layout>
                                <v-flex xs2 class="text-xs-right">
                                    <v-icon small color="grey">perm_identity</v-icon>
                                </v-flex>
                                <v-flex xs8 justify-left>
                                    <div class="grey--text">{{ person.idNumber }}</div>
                                </v-flex>
                            </v-layout>
                        </v-card-text>
                        <v-card-actions class="justify-center layout px-0">
                            <v-btn color="light-blue white--text" round @click="mergeBillingContact(person)">
                                <v-icon small>call_merge</v-icon>Merge
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-flex>
            </v-card-text>
            <v-card-actions>
                <v-layout justify-center>
                    <v-btn round color="primary" @click="similarContactsModalBilling = false">Cancel</v-btn>
                </v-layout>
            </v-card-actions>
        </v-card>
    </v-dialog>

    <!-- Edit Contact -->
    <v-dialog persistent v-model="editContactModal" max-width="750px">
        <v-card>
            <v-toolbar flat color="primary">
                <h3 class="headline white--text">EDIT CONTACT</h3>
            </v-toolbar>
            <v-card-text>
                <v-text-field v-model="editedContact.name" label="Name"></v-text-field>
                <v-text-field v-model="editedContact.surname" label="Surname"></v-text-field>
                <v-text-field v-model="editedContact.idNumber" label="ID Number"></v-text-field>
                <v-text-field v-model="editedContact.emailAddress" label="Email Address"></v-text-field>
                <v-text-field v-model="editedContact.mobileNumber" label="Mobile Number"></v-text-field>
            </v-card-text>
            <v-card-actions>
                <v-layout justify-center>
                    <v-btn round color="primary" @click="(editContactModal = false), (editedContact = {})">Cancel</v-btn>
                    <v-btn round color="primary" @click="saveEditedContact">Save</v-btn>
                </v-layout>
            </v-card-actions>
        </v-card>
    </v-dialog>

    <v-dialog persistent v-model="showProducts" max-width="1000px">
        <v-toolbar flat color="primary">
            <h3 class="title white--text">Products</h3>
            <v-spacer></v-spacer>
            <v-btn flat color="white" @click="showProducts = false">X</v-btn>
        </v-toolbar>
        <v-toolbar flat color="white">
            <v-spacer></v-spacer>
            <v-text-field label="Search" append-icon="search" v-model="search"></v-text-field>
        </v-toolbar>
        <v-data-table :headers="productHeaders" class="elevation-1" :items="products" :rows-per-page-items="[10, 20, 50, 100, 250]" :pagination.sync="pagination" item-key="id" align-center style="cursor: pointer" :search="search">
            <template v-slot:items="props">
                <td class="text-xs-center" v-if="props.item.locationNetworkProduct.stockItem">
                    {{ props.item.locationNetworkProduct.stockItem.name }}
                </td>
                <td class="text-xs-center" v-else>
                    {{ props.item.locationNetworkProduct.deviceMakeModel.name }}
                </td>
                <td class="text-xs-center" v-if="props.item.locationNetworkProduct.stockItem">
                    {{ props.item.locationNetworkProduct.stockItem.stockType.name }}
                </td>
                <td class="text-xs-center" v-else>
                    {{ props.item.locationNetworkProduct.deviceMakeModel.deviceMake.name }}
                </td>
                <td v-if="props.item.locationNetworkProduct.stockItem" class="text-xs-center">
                    {{ (props.item.locationNetworkProduct.stockItem.priceExclVat * (1 + $VAT)) | currency }}
                </td>
                <td v-else class="text-xs-center">
                    {{ props.item.locationNetworkProduct.deviceMakeModel.priceInclVat | currency }}
                </td>
            </template>
            <template v-slot:pageText="props">Records {{ props.pageStart }} - {{ props.pageStop }} of {{ props.itemsLength }}</template>
        </v-data-table>
    </v-dialog>

    <!-- Invoice Number Modal -->
    <v-dialog v-model="invoiceNumberDialog" max-width="750px">
        <v-card>
            <v-toolbar flat color="primary">
                <h3 class="headline white--text">INVOICE NUMBER</h3>
            </v-toolbar>
            <v-card-text>
                <v-text-field v-model="applicationInfo.invoiceNumber" label="Invoice Number"></v-text-field>
            </v-card-text>
            <v-card-actions>
                <v-layout justify-center>
                    <v-btn round color="primary" @click="(invoiceNumberDialog = false), (applicationInfo.invoiceNumber = '')">Cancel</v-btn>
                    <v-btn round color="primary" @click="saveInvoiceStatus">Save</v-btn>
                </v-layout>
            </v-card-actions>
        </v-card>
    </v-dialog>

    <v-dialog v-model="addTicketModal" width="1200px" persistent>
        <v-card>
            <TicketSummaryModal :ticket="ticketItem" @close="addTicketModal=false, ticketItem={}" @ticketCreated="addTicketModal=false,fetchTickets()" :key="ticketKey" />
        </v-card>
    </v-dialog>

    <!-- Provisioning Warning Modal -->
    <v-dialog v-model="provisionWarningModal" persistent max-width="450px" min-width="450px">
        <v-card flat color="white">
            <v-toolbar flat color="orange">
                <h3 class="title white--text">Conflict</h3>
                <v-spacer></v-spacer>
                <v-btn v-if="authAdmin($store.state.currentRoute)" flat color="white" @click="provisionWarningModal = false">X</v-btn>
            </v-toolbar>
            <v-card-text v-if="!authAdmin($store.state.currentRoute) && provisionTemplate">
                <span mx-4 class="grey--text">The provisioning template for this ISP is set to provision on Ethernet port
                    {{ provisionTemplate.tpIndex }}, there is however already an existing service on this port. Please contact
                    your system administrator for further assistance.</span>
            </v-card-text>
            <v-card-text v-else-if="provisionTemplate">
                <span mx-4 class="grey--text">
                    There are already services provisioned on Ethernet port
                    {{ provisionTemplate.tpIndex }}.
                    <br />
                    <br />
                </span>
                <div v-if="ethPorts.filter((x) => !deviceBridges.map((y) => y.tpIndex).includes(x)).length > 0">
 <span mx-4 class="grey--text">
                    Please select another port to provision services to:
                </span>
              <v-radio-group v-model="changedPort">
      <v-radio
        v-for="n in ethPorts.filter((x) => !deviceBridges.map((y) => y.tpIndex).includes(x))"
        :key="n"
        :label="`Eth Port ${n}`"
        :value="n"
      ></v-radio>
    </v-radio-group>
                </div>


                <!-- <v-select xs3 v-if="ethPorts.filter((x) => !deviceBridges.map((y) => y.tpIndex).includes(x)).length > 0" v-model="changedPort" label="Please select another port to provision services" :items="ethPorts.filter((x) => !deviceBridges.map((y) => y.tpIndex).includes(x))"></v-select> -->
               
                <span class="grey--text" v-else>There are currently no unprovisioned ports.</span>
            </v-card-text>
            <v-card-actions>
                <v-layout justify-center>
                    <v-btn v-if="!authAdmin($store.state.currentRoute)" round color="primary" class="white--text" @click="provisionWarningModal = false">Okay</v-btn>
                    <v-btn v-if="ethPorts.filter((x) => !deviceBridges.map((y) => y.tpIndex).includes(x)).length == 0" round color="primary" class="white--text" @click="provisionWarningModal = false">Okay</v-btn>
                    <v-btn v-else-if="authAdmin($store.state.currentRoute)" round color="primary" class="white--text" @click="processPortChange()">Process</v-btn>
                </v-layout>
            </v-card-actions>
        </v-card>
    </v-dialog>

    <v-dialog v-model="configModal" width="750px">
        <v-card color="white" flat>
            <v-toolbar color="primary" flat>
                <h3 class="title white--text">SERVICE CONFIGURATION</h3>
                <v-spacer></v-spacer>
                <v-btn color="white" flat @click="(configModal = false), (configurationSettings = {})">X</v-btn>
            </v-toolbar>
            <v-card-text>
                <div v-if="configurationSettings.type == 'Multiple'">
                    <v-layout justify-center align-center wrap>
                        <v-flex xs10 mx-1 my-1 v-if="configurationSettings.bridgeTemplates.length > 1">
                            <h4 class="grey--text">
                                There are multiple configurations available for this device. Please choose the preferred
                                configuration:
                            </h4>
                        </v-flex>
                        <v-flex xs8 mx-1 mt-2 v-for="template in configurationSettings.bridgeTemplates" :key="template.id">
                            <v-card color="white" :hover="configurationSettings.selectedTemplateId !== template.id" @click="
                    (configurationSettings.selectedTemplateId = template.id),
                      (configurationSettings.connectionType = template.connectionType)
                  ">
                                <v-toolbar flat :color="configurationSettings.selectedTemplateId == template.id ? 'light-green' : 'primary'">
                                    <h3 class="title white--text" v-if="template.type == 'OneDevice'">
                                        One Device
                                    </h3>
                                    <h3 class="title white--text" v-else>Two Device</h3>
                                    <v-spacer></v-spacer>
                                    <v-icon large v-if="configurationSettings.selectedTemplateId == template.id" color="white">check_circle</v-icon>
                                </v-toolbar>
                                <v-card-text>
                                    <v-layout justify-left align-center mx-1 wrap class="text-xs-left">
                                        <v-flex xs4 mx-1>
                                            <h3 class="grey--text">Connection Type:</h3>
                                        </v-flex>
                                        <v-flex xs4 mx-1>
                                            <h3 class="grey--text font-weight-light">
                                                {{ template.connectionType }}
                                            </h3>
                                        </v-flex>
                                        <v-flex xs4 mx-1 v-if="template.innerVlan != 0">
                                            <h3 class="grey--text">Inner VLAN:</h3>
                                        </v-flex>
                                        <v-flex xs4 mx-1 v-if="template.innerVlan != 0">
                                            <h3 class="grey--text font-weight-light">
                                                {{ template.innerVlan }}
                                            </h3>
                                        </v-flex>
                                        <v-flex xs4 mx-1 v-if="template.outerVlan != 0">
                                            <h3 class="grey--text">Outer VLAN:</h3>
                                        </v-flex>
                                        <v-flex xs4 mx-1 v-if="template.outerVlan != 0">
                                            <h3 class="grey--text font-weight-light">
                                                {{ template.outerVlan }}
                                            </h3>
                                        </v-flex>
                                        <v-flex xs4 mx-1 v-if="template.type == 'TwoDevice'">
                                            <h3 class="red--text">Terms:</h3>
                                        </v-flex>
                                        <v-flex xs6 mx-1 v-if="template.type == 'TwoDevice'">
                                            <h3 class="red--text font-weight-light">
                                                Second device is NOT provided by the network operator and will need to either be supplied by
                                                the ISP or the end customer.
                                            </h3>
                                        </v-flex>
                                    </v-layout>
                                </v-card-text>
                            </v-card>
                        </v-flex>
                    </v-layout>
                </div>
                <div v-if="configurationSettings.connectionType && configurationSettings.connectionType.toLowerCase() == 'pppoe'">
                    <v-layout align-center justify-center wrap my-1>
                        <v-flex xs10 mx-1 mt-2>
                            <h3 class="title grey--text">PPPoE Configuration</h3>
                        </v-flex>
                        <v-flex xs4 mx-1>
                            <v-text-field label="PPPoE Username" v-model="configurationSettings.pppoeUsername"></v-text-field>
                        </v-flex>
                        <v-flex xs4 mx-1>
                            <v-text-field label="PPPoE Password" placeholder="Leave blank to auto-generate" v-model="configurationSettings.pppoePassword"></v-text-field>
                        </v-flex>
                    </v-layout>
                </div>
            </v-card-text>
            <v-card-actions>
                <v-layout justify-center align-center>
                    <v-btn round color="primary" class="white--text" v-if="
                configurationSettings.selectedTemplateId &&
                  configurationSettings.connectionType &&
                  configurationSettings.connectionType.toLowerCase() != 'pppoe'
              " @click="submitConfiguration()">Submit</v-btn>
                    <v-btn round color="primary" class="white--text" v-else-if="
                configurationSettings.selectedTemplateId &&
                  configurationSettings.connectionType &&
                  configurationSettings.connectionType.toLowerCase() == 'pppoe' &&
                  configurationSettings.pppoeUsername
              " @click="submitConfiguration()">Submit</v-btn>
                    <v-btn round color="primary" class="white--text" v-else disabled>Submit</v-btn>
                </v-layout>
            </v-card-actions>
        </v-card>
    </v-dialog>

    <v-dialog v-model="documentsModal" persistent width="750px">
        <v-card>
            <v-toolbar flat color="white">
                <v-toolbar-title>
                    Documents
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn flat @click="documentsModal=false">X</v-btn>
            </v-toolbar>
            <v-card-text>
                <v-layout justify-center align-center wrap>
                    <v-flex xs12 v-for="document in documents" :key="document.id">
                        <v-card flat color="white" style="border-top: 1px solid lightgrey">
                            <v-layout justify-left align-center wrap>
                                <v-flex xs2>
                                    <h4 class="grey--text font-weight-light">{{formatDate(new Date(document.createdAt))}}</h4>
                                </v-flex>
                                <v-flex xs6>
                                    <h4 class="grey--text">{{document.name}}</h4>
                                </v-flex>
                                <v-flex xs2>
                                    <v-switch v-model="document.share" @change="updateDocument(document)" label="Shared"></v-switch>
                                </v-flex>
                                <v-flex xs2>
                                    <v-layout justify-center>
                                        <!-- <v-icon @click="viewFile(document)">open_in_new</v-icon> -->
                                        <v-icon @click="downloadFile(document)">download</v-icon>
                                        <v-icon color="red" @click="deleteFile(document)">delete</v-icon>
                                    </v-layout>
                                </v-flex>
                            </v-layout>
                        </v-card>
                    </v-flex>
                </v-layout>
            </v-card-text>
        </v-card>
    </v-dialog>

</div>
</template>

<script>
import Api from "@/services/Api";
import dateformat from "dateformat";
import DeviceCrud from "@/components/DeviceCrud.vue";
import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
import "vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css";
import LineChart from "../components/LineChart";
import DocumentCard from "@/components/DocumentCard.vue";
import GmapCustomMarker from "vue2-gmap-custom-marker";
import SageInvoiceModal from "../components/SageInvoiceModal";
import SageTransactions from "../components/SageTransactions";
import TicketSummaryModal from '../components/TicketSummaryModal.vue'
import At from "vue-at";
import AtTa from "vue-at/dist/vue-at-textarea"; // for textarea
export default {
    components: {
        "gmap-custom-marker": GmapCustomMarker,
        VueCtkDateTimePicker: VueCtkDateTimePicker,
        documentcomponent: DocumentCard,
        linechart: LineChart,
        SageInvoiceModal,
        SageTransactions,
        TicketSummaryModal,
        At,
        AtTa,
    },
    data() {
        return {
            members: [],
            file: '',
            membersEmail: [],
            commentArray: [],
            documentsModal: false,
            editLocation: false,
            internal: true,
            mentioned: null,
            emailAddressArray: [],
            serviceAccountIndex: 0,
            ageAnalysis: null,
            center: {
                lng: -33.919473,
                lat: 18.427059
            },
            ticketCarousalArray: [],
            ticketIndex: 0,
            applicationContactIndex: 0,
            bridgeTemplates: [],
            configurationSettings: {},
            configModal: false,
            datatillIntegration: false,
            datatillContactType: null,
            datatillContactTypeList: [],
            documents: [],
            allCustomers: [],
            addCustomerModal: false,
            createNewDatatillCustomer: true,
            existingDatatillCustomer: false,
            selected: [],
            newCustomer: {},
            foundExisting: [],
            index: 0,
            pages: [],
            stepperModel: null,
            initialAccessBuildFee: 0,
            initialAccessBuildDocument: "",
            keyAdditionalAccessBuildDocument: 0,
            ticketCategoryId: null,
            feasibilityTests: [],
            lineChartData: null,
            userRoles: [],
            productHeaders: [{
                    text: "Name",
                    align: "center",
                    value: "locationNetworkProduct.stockItem.name",
                },
                {
                    text: "Type",
                    align: "center",
                    value: "locationNetworkProduct.stockItem.stockType.name",
                },
                {
                    text: "Price Incl. VAT",
                    align: "center",
                    value: "locationNetworkProduct.stockItem.priceExclVat",
                },
            ],
            showProducts: false,
            products: [],
            locations: [],
            locationLength: 0,
            subComplexes: [],
            locationTypes: [],
            searchLocation: null,
            locations: [],
            locationHeaders: [{
                    text: "Action",
                    align: "center",
                    sortable: false,
                },
                {
                    text: "Unit No",
                    align: "center",
                    value: "unitNo",
                },
                {
                    text: "Erf No",
                    align: "center",
                    value: "erfNo",
                },
                {
                    text: "Other No",
                    align: "center",
                    value: "otherNo",
                },
                {
                    text: "Street Name",
                    align: "center",
                    value: "complexStreetName",
                },
                {
                    text: "Sub Complex",
                    align: "center",
                    value: "locationNetworkSubComplex.subcomplexName",
                },
                {
                    text: "Network",
                    align: "center",
                    value: "locationNetwork.name",
                },
            ],
            secondaryDeviceHeader: [{
                    text: "Model",
                    align: "center",
                    value: "deviceMakeModel.name",
                },
                {
                    text: "Pon Mac",
                    align: "center",
                    value: "ponMac",
                },
                {
                    text: "Serial Number",
                    align: "center",
                    value: "serialNumber",
                },
                {
                    text: "Warehouse",
                    align: "center",
                    value: "stockWarehouse.name",
                },
            ],
            secondaryDeviceSearch: "",
            keySearch: 0,
            availableSecondaryDeviceList: [],
            secondaryDevice: null,
            secondaryDeviceKey: 0,
            locationSearch: "",
            filteredLocations: [],
            locationFilter: null,
            locationNetworks: [],
            attachExistingLocation: false,
            attachLocationModal: false,
            snackbar: false,
            text: "",
            editedContact: {},
            editContactModal: false,
            invoice: null,
            invoiceNumberDialog: false,
            loadingApplication: false,
            xeroContacts: [],
            similarXeroContacts: [],
            installation: {},
            today: this.formatDate(new Date()),
            addInstallationModal: false,
            deniedReasonModal: false,
            filteredUsers: [],
            applicationInfo: "",
            search: "",
            page: 1,
            allDevices: [],
            device: null,
            existingServiceAccounts: [],
            locationContacts: [],
            showApplicationContacts: true,
            showLocationContacts: 0,
            linkedPrimaryContacts: [],
            linkedSecondaryContacts: [],
            deniedReason: "",
            linkedBillingContacts: [],
            similarContactsModalPrimary: false,
            similarContactsModalSecondary: false,
            similarContactsModalBilling: false,
            xeroContactsModal: false,
            billedXeroContactId: null,
            provisionTemplate: null,
            verifyingContact: false,
            verifyingInstallation: false,
            verifyingDevice: false,
            creatingPrimaryContact: false,
            creatingSecondaryContact: false,
            creatingBillingContact: false,
            tickets: [],
            addTicketModal: false,
            ticketItem: {
                ticketCategoryId: 2,
            },
            ticketCommentLog: [],
            ticketAssignedLog: [],
            deviceBridges: [],
            provisionWarningModal: false,
            ethPorts: [1, 2, 3, 4],
            changedPort: null,
            ticketKey: 0,
            dateTimeSelect: false,
            y: "top",
            devicesLength: 0,
            pagination: {
                totalItems: 0
            },
            invoices: [],
            quotes: [],
            transactions: [],
            billingTab: "invoices",
            invoiceItem: {},
            invoiceModal: false,
            taxTypes: [],
            tabs: [{
                    name: "applicationContacts",
                    displayName: "Application Contacts"
                },
                {
                    name: "locationContacts",
                    displayName: "Location Contacts"
                },
            ],
            transactionHeaders: [{
                    text: "Action",
                    align: "center",
                    sortable: false,
                },
                {
                    text: "Document No.",
                    align: "center",
                    value: "DocumentNumber",
                },
                {
                    text: "Date",
                    align: "center",
                    value: "Date",
                },
                {
                    text: "Amount",
                    align: "center",
                    value: "Total",
                },
                {
                    text: "Status",
                    align: "center",
                    value: "AmountDue",
                },
            ],
            locationTypeList: ["End Location", "Location Network", "Location Node", "Switching Centre"],
            locationType: "End Location",
            tributeOptions: {
                lookup: "name",
                values: this.users
            },
            addCommentBox: false,
            comment: "",
            ticketItem: {},
            headers: [{
                    text: "Action",
                    align: "center",
                },
                {
                    text: "System Name",
                    align: "center",
                    value: "systemName",
                },
                {
                    text: "Location",
                    align: "center",
                    value: "location.locationDescription",
                },
                {
                    text: "Network",
                    align: "center",
                    value: "locationNetwork.name",
                },
                {
                    text: "Node",
                    align: "center",
                    value: "locationNode.name",
                },
                {
                    text: "Switching Centre",
                    align: "center",
                    value: "switchingCentre.name",
                },
                {
                    text: "Make",
                    align: "center",
                    value: "deviceMakeModel.deviceMake.name",
                },
                {
                    text: "Type",
                    align: "center",
                    value: "deviceMakeModel.deviceType.name",
                },
                {
                    text: "Model",
                    align: "center",
                    value: "deviceMakeModel.name",
                },
                {
                    text: "IP Address",
                    align: "center",
                    value: "ipAddress",
                },
                {
                    text: "Serial Number",
                    align: "center",
                    value: "serialNumber",
                },
                {
                    text: "Pon Mac",
                    align: "center",
                    value: "ponMac",
                },
                {
                    text: "Mac Address",
                    align: "center",
                    value: "macAddress",
                },
                {
                    text: "Pon Numerical",
                    align: "center",
                    value: "ponNumerical",
                },
                {
                    text: "Product Number",
                    align: "center",
                    value: "productNumber",
                },

                {
                    text: "Upstream Device",
                    align: "center",
                    value: "upstreamDevice.deviceMakeModel.name",
                },
                {
                    text: "PON Address",
                    align: "center",
                    value: "ponAddress",
                },
                {
                    text: "PON ID",
                    align: "center",
                    value: "ponId",
                },
                {
                    text: "Frame",
                    align: "center",
                    value: "frame",
                },
                {
                    text: "Slot",
                    align: "center",
                    value: "slot",
                },
                {
                    text: "Port",
                    align: "center",
                    value: "port",
                },
                {
                    text: "Note",
                    align: "center",
                    value: "note",
                },
                {
                    text: "Active",
                    align: "center",
                    value: "isActive",
                },
            ],
        };
    },
    async created() {
        this.commentArray = [];
        this.$router.push({
            name: this.$route.name,
            query: {
                offset: "0",
                records: "10"
            },
        });
        this.initialize();
    },
    computed: {
        // Jackal Creek / SkyCo: approve and bill without a completed installation (server: src/noInstallOrgs.js)
        installNotRequired() {
            return !!this.applicationInfo && [346, 362].includes(parseInt(this.applicationInfo.organisationId, 10));
        },
        formattedAddress() {
            let address = ''
            if (this.applicationInfo.unitNo) {
                address += 'Unit ' + this.applicationInfo.unitNo + ', '
            }
            if (this.applicationInfo.floorNo) {
                address += 'Floor ' + this.applicationInfo.floorNo + ', '
            }
            if (this.applicationInfo.building) {
                address += this.applicationInfo.building + ', '
            }
            if (this.applicationInfo.streetNumber) {
                address += this.applicationInfo.streetNumber + ' '
            }
            if (this.applicationInfo.streetName) {
                address += this.applicationInfo.streetName + ', '
            }
            if (this.applicationInfo.suburb) {
                address += this.applicationInfo.suburb + ', '
            }
            if (this.applicationInfo.town) {
                address += this.applicationInfo.town + ', '
            }
            if (this.applicationInfo.province) {
                address += this.applicationInfo.province + ', '
            }
            if (this.applicationInfo.country) {
                address += this.applicationInfo.country
            }
            if (this.applicationInfo.postalCode) {
                address += ' ' + this.applicationInfo.postalCode
            }
            return address
        }
    },
    watch: {
searchLocation(val) {
            // Items have already been loaded
            // if (this.locations.length > 0) return

            // Items have already been requested
            if (this.isLoading) return

            this.isLoading = true

            // Lazily load input items
            Api().get('/Locations/elasticSearch', {
                params: {
                    search: val
                }
            }).then(res => {
                this.locations = res.data
            }).finally(() => (this.isLoading = false))
        },
        "$route.query.search": {
            immediate: true,
            handler(value) {
                this.isLoading = true;
                if (this.$route.query.search && value !== "" && value != null) {
                    Api()
                        .get("/devices/active", {
                            params: {
                                search: value,
                                offset: "0",
                                records: this.$route.query.records,
                            },
                        })
                        .then((response) => {
                            this.allDevices = response.data.result;
                            this.pagination.totalItems = response.data.count;
                            this.devicesLength = response.data.count;
                            this.isLoading = false;
                        });
                } else if (this.$route.query.offset && this.$route.query.records) {
                    Api()
                        .get("/devices/active", {
                            params: {
                                offset: "0",
                                records: this.$route.query.records,
                            },
                        })
                        .then((response) => {
                            this.allDevices = response.data.result;
                            this.pagination.totalItems = response.data.count;
                            this.devicesLength = response.data.count;
                            this.isLoading = false;
                        });
                }
            },
        },
        "$route.query.offset": {
            immediate: true,
            handler(value) {
                this.isLoading = true;
                if (
                    value !== "" &&
                    value != null &&
                    this.$route.query.search &&
                    this.$route.query.search != "" &&
                    this.$route.query.search !== null
                ) {
                    Api()
                        .get("/devices/active", {
                            params: {
                                search: this.$route.query.search,
                                offset: this.$route.query.offset,
                                records: this.$route.query.records,
                            },
                        })
                        .then((response) => {
                            this.devices = response.data;
                            this.devicesLength = this.devices.length;
                            this.isLoading = false;
                        });
                } else if (value !== "" && value != null) {
                    Api()
                        .get("/devices/active", {
                            params: {
                                offset: this.$route.query.offset,
                                records: this.$route.query.records,
                            },
                        })
                        .then((response) => {
                            this.allDevices = response.data.result;
                            this.pagination.totalItems = response.data.count;
                            this.devicesLength = response.data.count;
                            this.isLoading = false;
                        });
                }
            },
        },
        page(value) {
            this.pagination.page = this.page;
            if (value && value != "" && value != this.$route.query.records) {
                if (this.$route.query.search) {
                    this.$router.push({
                        name: this.$route.name,
                        query: {
                            offset: (value - 1) * this.$route.query.records,
                            records: this.$route.query.records,
                            search: this.$route.query.search,
                        },
                    });
                } else {
                    this.$router.push({
                        name: this.$route.name,
                        query: {
                            offset: (value - 1) * this.$route.query.records,
                            records: this.$route.query.records,
                        },
                    });
                }
            }
        },
        locationFilter(value) {
            if (value !== null && typeof value !== "undefined") {
                this.filteredLocations = this.locations.filter(function (el) {
                    return el.locationNetworkId === value;
                });
                this.locationLength = this.filteredLocations.length;
            } else {
                this.filteredLocations = this.locations;
                this.locationLength = this.filteredLocations.length;
            }
        },
        "$route.query.search": {
            immediate: true,
            handler(value) {
                if (this.$route.query.search && value !== "" && value != null) {
                    Api()
                        .get("/Locations/byNetwork/" + this.applicationInfo.locationNetworkId + "/activeFilter", {
                            params: {
                                search: value,
                                offset: "0",
                                records: this.$route.query.records,
                            },
                        })
                        .then((response) => {
                            this.filteredLocations = response.data.result;
                            this.locationLength = response.data.count;
                        });
                } else if (this.$route.query.offset) {
                    Api()
                        .get("/Locations/byNetwork/" + this.applicationInfo.locationNetworkId + "/activeFilter", {
                            params: {
                                offset: this.$route.query.offset,
                                records: this.$route.query.records,
                            },
                        })
                        .then((response) => {
                            this.filteredLocations = response.data.result;
                            this.locationLength = response.data.count;
                        });
                }
            },
        },
        "$route.query.offset": {
            immediate: true,
            handler(value) {
                this.loading = true;
                if (
                    value !== "" &&
                    value != null &&
                    this.$route.query.search &&
                    this.$route.query.search != "" &&
                    this.$route.query.search !== null
                ) {
                    Api()
                        .get("/Locations/byNetwork/" + this.applicationInfo.locationNetworkId + "/activeFilter", {
                            params: {
                                search: this.$route.query.search,
                                offset: this.$route.query.offset,
                                records: this.$route.query.records,
                            },
                        })
                        .then((response) => {
                            this.filteredLocations = response.data.result;
                            this.locationLength = response.data.count;
                        });
                } else if (value !== "" && value != null) {
                    Api()
                        .get("/Locations/byNetwork/" + this.applicationInfo.locationNetworkId + "/activeFilter", {
                            params: {
                                offset: this.$route.query.offset,
                                records: this.$route.query.records,
                            },
                        })
                        .then((response) => {
                            this.filteredLocations = response.data.result;
                            this.locationLength = response.data.count;
                        });
                }
            },
        },
    },
    methods: {
        contactVerified() {
            let result = this.applicationInfo.isContactVerified ? this.applicationInfo.isContactVerified : this.applicationInfo.primaryContactId == null
            return result
        },
        downloadFile(item) {
            const linkSource = `data:${item.type};base64,${item.base64}`;
            const downloadLink = document.createElement("a");
            const fileName = item.name;
            downloadLink.href = linkSource;
            downloadLink.download = fileName;
            downloadLink.click();
        },
        deleteFile(item) {
            Api().put('/upload/' + item.id, {
                isActive: false,
                isDeleted: true
            }).then(res => {
                this.documents.splice(this.documents.indexOf(item), 1)
            })
        },
        async selectFile(event) {
            await this.uploadFile(event.srcElement.files[0]);
        },
        async uploadFile(file) {
            var reader = await new FileReader();
            await reader.readAsDataURL(file);
            reader.onload = () => {
                this.setResult(reader.result);
            };
            reader.onerror = function () {
                console.log("there are some problems");
            };
        },
        setResult(result) {
            this.applicationInfo.additionalAccessBuildDocument = result;
            this.keyAdditionalAccessBuildDocument += 1;
        },
        async routeToTicketSummary(item) {
            this.$router.push({
                path: "/ticketSummary/" + item
            });
        },
        addComment(comment) {
            this.ticketCommentLog.push({
                commentedBy: this.$store.state.user,
                commentedById: this.$store.state.user.id,
                comment: comment,
                type: "comment",
                createdAt: new Date(),
            });
            this.comment = "";
            this.addCommentBox = false;
        },
        removeContact(item) {
            if (this.authUpdate(this.$store.state.currentRoute)) {
                Api()
                    .put("/LocationContact/" + item.id, {
                        isDeleted: true,
                        isActive: false,
                    })
                    .then((response) => {
                        let index = this.locationContacts.indexOf(item);
                        this.locationContacts.splice(index, 1);
                        if(this.locationContacts.length==0){
                            this.showLocationContacts = 0
                        }
                    });
            }
        },
        formatDateTime(date) {
            if (date !== null) {
                return dateformat(date, "yyyy-mm-dd HH:MM");
            } else {
                null;
            }
        },
        formatDate(date) {
            if (date !== null) {
                return dateformat(date, "yyyy-mm-dd");
            } else {
                null;
            }
        },
        processPortChange() {
            if (this.provisionTemplate != null) {
                if (this.changedPort) {
                    this.provisionTemplate.tpIndex = this.changedPort;
                }
                let ponId = this.device.gponOnuId.toString();
                if (this.provisionTemplate.gponOnuId < 10) {
                    ponId = "0" + ponId;
                }

                if (!this.provisionTemplate.autoSelectGemPortValue) {
                    this.provisionTemplate.gponPortId = "3" + this.provisionTemplate.tpIndex.toString() + ponId;
                } else {
                    this.provisionTemplate.gponPortId = 0;
                }
                this.changedPort = null;
                this.provisionWarningModal = false;
                this.approveApplication();
            }
        },
        prepareZhoneTemplate() {
            if (this.provisionTemplate != null) {
                this.provisionTemplate.Device_ID = this.device.Device_ID;
                this.provisionTemplate.Handle_ID = this.device.Handle_ID;
                this.provisionTemplate.gponSlotId = this.device.gponSlotId;
                this.provisionTemplate.gponOltId = this.device.gponOltId;
                this.provisionTemplate.gponPortId = this.device.gponPortId;

                this.provisionTemplate.gponOnuId = this.device.gponOnuId;
                if (this.changedPort) {
                    this.provisionTemplate.tpIndex = this.changedPort;
                }
                let ponId = this.device.gponOnuId.toString();
                if (this.provisionTemplate.gponOnuId < 10) {
                    ponId = "0" + ponId;
                }

                if (!this.provisionTemplate.autoSelectGemPortValue) {
                    this.provisionTemplate.gponPortId = "3" + this.provisionTemplate.tpIndex.toString() + ponId;
                } else {
                    this.provisionTemplate.gponPortId = 0;
                }
            }
        },

        makeContactId(length) {
            var result = "";
            var characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
            var charactersLength = characters.length;
            for (var i = 0; i < length; i++) {
                result += characters.charAt(Math.floor(Math.random() * charactersLength));
            }
            return result;
        },
        similarity(s1, s2) {
            var longer = s1;
            var shorter = s2;
            if (s1.length < s2.length) {
                longer = s2;
                shorter = s1;
            }
            var longerLength = longer.length;
            if (longerLength == 0) {
                return 1.0;
            }
            return (longerLength - this.editDistance(longer, shorter)) / parseFloat(longerLength);
        },
        editDistance(s1, s2) {
            s1 = s1.toLowerCase();
            s2 = s2.toLowerCase();

            var costs = new Array();
            for (var i = 0; i <= s1.length; i++) {
                var lastValue = i;
                for (var j = 0; j <= s2.length; j++) {
                    if (i == 0) costs[j] = j;
                    else {
                        if (j > 0) {
                            var newValue = costs[j - 1];
                            if (s1.charAt(i - 1) != s2.charAt(j - 1))
                                newValue = Math.min(Math.min(newValue, lastValue), costs[j]) + 1;
                            costs[j - 1] = lastValue;
                            lastValue = newValue;
                        }
                    }
                }
                if (i > 0) costs[s2.length] = lastValue;
            }
            return costs[s2.length];
        },
        fetchDocuments() {
            Api()
                .get("/upload/byApplication/" + this.applicationInfo.id)
                .then((res) => {
                    this.documents = res.data;
                });
        },
        fetchOrgContacts() {
            this.filteredUsers = [];
            Api()
                .get("/organisationContact")
                .then(async (response) => {
                    this.filteredUsers = response.data.filter(function (el) {
                        return el.userType !== "endClient";
                    });
                    let contactArray = await this.filteredUsers.map((x) => x.contact);
                    this.members = await contactArray.map((x) => x.name + " " + x.surname);
                    await contactArray.map((x) => {
                        this.membersEmail.push({
                            fullName: x.name + " " + x.surname,
                            email: x.emailAddress,
                        });
                    });
                    this.filteredUsers = contactArray;
                });
        },
        fetchProducts() {
            Api()
                .get("/applicationLocationNetworkProduct/byApplication/" + this.$route.params.applicationId)
                .then((response) => {
                    this.products = response.data;
                });
        },
        updateDocument(document) {
            Api().put('/upload/' + document.id, document)
        },
        async initialize() {
            await this.getApplication();
            this.fetchApplicationComments();
            this.fetchProducts();
            this.fetchLocationNetworks();
            this.getExistingServiceAccounts();
            this.fetchTickets();
            this.fetchOrgContacts();
            this.getlocationTypes();
            this.fetchDocuments();
            if (this.device) {
                this.fetchDeviceBridges(this.device.id);
                this.getAvailableTemplates(this.device.deviceMakeModel.deviceMakeId);
            }
        },
        routeToOrganisation(id) {
            this.$router.push({
                path: "/ispList/" + id
            });
        },
        routeToDevice(id) {
            this.$router.push({
                path: "/devices/" + id
            });
        },
        routeToServiceAccount(id) {
            this.$router.push({
                path: "/serviceAccounts/" + id
            });
        },
        fetchApplicationComments() {
            this.commentArray = [];
            Api()
                .get("/applicationComment/byApplication/" + this.$route.params.applicationId)
                .then(async (response) => {
                    this.commentArray = response.data.map((x) =>
                        ({
                            organisation: x.organisation,
                            commentedById: x.commentedById,
                            commentedByName: x.commentedBy.name,
                            commentedBySurname: x.commentedBy.surname,
                            comment: x.comment,
                            type: x.type,
                            createdAt: x.createdAt,
                            isInternal: x.isInternal,
                            id: x.id,
                            commentLogType: true,
                        })
                    )
                    this.commentArray.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
                });
        },
        async fetchTransactions(id) {
            await Api()
                .get("/sageOne/customer/transactions/" + id)
                .then((res) => {
                    if (res.data.length > 0) {
                        this.transactions = res.data;
                        this.invoices = res.data;
                    }
                });
        },
        fetchSageCustomerDetails(customerId) {
            Api()
                .get("/sageOne/ageAnalysisSummary/" + customerId)
                .then((res) => {
                    this.ageAnalysis = res.data;
                });
        },
        createSageRecurringInvoice() {
            let today = new Date();
            today.setDate(1);
            today.setMonth(today.getMonth() + 1);
            let obj = {
                CustomerId: parseInt(this.applicationInfo.accountingCustomerId),
                Schedule: {
                    StartDate: [
                        today.getFullYear(),
                        today.getMonth() + 1 < 10 ? "0" + (today.getMonth() + 1).toString() : today.getMonth() + 1,
                        today.getDate() < 10 ? "0" + today.getDate().toString() : today.getDate(),
                    ].join("-"),
                    ScheduleFrequencyId: 5,
                    Active: true,
                },
                RecurringProfile: {
                    AutoCreate: true,
                    DueDateMethodId: 0,
                    DueDateMethodValue: 7,
                },
                Date: [
                    today.getFullYear(),
                    today.getMonth() + 1 < 10 ? "0" + (today.getMonth() + 1).toString() : today.getMonth() + 1,
                    today.getDate() < 10 ? "0" + today.getDate().toString() : today.getDate(),
                ].join("-"),
                DueDateMethodId: 1,
                DueDateMethodValue: 1,
                ExternalReference: this.applicationInfo.id,
                Lines: [{
                    SelectionId: parseInt(this.applicationInfo.packagesIsp.accountCode),
                    LineType: 1,
                    TaxTypeId: 123125,
                    UnitPriceExclusive: this.applicationInfo.ispRecurringPriceVatInc / (1 + $VAT),
                    Quantity: 1,
                }, ],
            };
            Api()
                .post("/sageOne/createRecurringInvoice", obj)
                .then(async (res) => {
                    if (res.data.ID) {
                        await Api().put("/applications/" + this.applicationInfo.id, {
                            recurringInvoiceId: res.data.ID,
                            recurringInvoiceNumber: res.data.DocumentNumber,
                        });
                        this.applicationInfo.recurringInvoiceId = res.data.ID;
                        this.applicationInfo.recurringInvoiceNumber = res.data.DocumentNumber;
                    }
                });
        },
        checkDatatillIntegration() {
            Api()
                .get("/integrations/byName/Datatill")
                .then((response) => {
                    if (response.data) {
                        this.datatillIntegration = true;
                        this.fetchDatatillCustomer();
                    }
                });
        },
        async getAvailableTemplates(deviceMakeId) {
            Api()
                .get(
                    "/customer/organisationBridgeTemplate/byCustomerDeviceMake/" +
                    deviceMakeId +
                    "/" +
                    this.$store.state.currentOrg.org.id
                )
                .then((response) => {
                    this.bridgeTemplates = response.data;
                });
        },
        fetchDatatillCustomer() {
            this.datatillContactType = "Primary";
            this.datatillContactTypeList = [];
            if (this.applicationInfo.primaryContactEmailAddress) {
                this.datatillContactTypeList.push("Primary");
            }
            if (this.applicationInfo.secondaryContactEmailAddress) {
                this.datatillContactTypeList.push("Secondary");
            }
            if (this.applicationInfo.billingContactEmailAddress) {
                this.datatillContactTypeList.push("Billing");
            }
            Api()
                .post("/datatill/customerList", {
                    organisationId: this.$store.state.currentOrg.org.id,
                    primaryContactEmail: this.applicationInfo.primaryContactEmailAddress,
                    secondaryContactEmail: this.applicationInfo.secondaryContactEmailAddress,
                    billingContactEmail: this.applicationInfo.billingContactEmailAddress,
                    // contactEmail: 'cornelis.vanrensburg@gmail.com'
                })
                .then((response) => {
                    this.allCustomers = response.data.allCustomers;
                    this.foundExisting = [];
                    if (response.data.primaryCustomerId !== null) {
                        this.foundExisting.push({
                            type: "Primary",
                            customerId: response.data.primaryCustomerId,
                            fullName: this.applicationInfo.primaryContactFirstname + " " + this.applicationInfo.primaryContactLastname,
                            email: this.applicationInfo.primaryContactEmailAddress,
                            mobile: this.applicationInfo.primaryContactMobileNumber,
                            idNumber: this.applicationInfo.primaryContactIdNumber,
                        });
                        // this.applicationInfo.datatillCustomerId = response.data.customerId
                        // this.existingDatatillCustomer = true
                    }
                    if (response.data.secondaryCustomerId !== null) {
                        this.foundExisting.push({
                            type: "Secondary",
                            customerId: response.data.secondaryCustomerId,
                            fullName: this.applicationInfo.secondaryContactFirstname + " " + this.applicationInfo.secondaryContactLastname,
                            email: this.applicationInfo.secondaryContactEmailAddress,
                            mobile: this.applicationInfo.secondaryContactMobileNumber,
                            idNumber: this.applicationInfo.secondaryContactIdNumber,
                        });
                        // this.existingDatatillCustomer = true
                    }
                    if (response.data.billingCustomerId !== null) {
                        this.foundExisting.push({
                            type: "Billing",
                            customerId: response.data.billingCustomerId,
                            fullName: this.applicationInfo.billingContactFirstname + " " + this.applicationInfo.billingContactLastname,
                            email: this.applicationInfo.billingContactEmailAddress,
                            mobile: this.applicationInfo.billingContactMobileNumber,
                            idNumber: this.applicationInfo.billingContactIdNumber,
                        });
                        // this.existingDatatillCustomer = true
                    }
                });
        },
        ispVerifyModal() {
            if (this.bridgeTemplates.length == 0) {
                if (this.applicationInfo.organisationId == 336) {
                    if (confirm("This device has no configuration template on file for Purple Forest FTTB, so a manual configuration ticket will be created instead of an automated one. Are you sure you would like to approve this application?")) {
                        this.configurationSettings = {
                            type: "None",
                            connectionType: "IPoE",
                            bridgeTemplates: [],
                            selectedTemplateId: null,
                            pppoeUsername: null,
                            pppoePassword: null,
                        };
                        this.submitConfiguration();
                    }
                } else {
                    confirm(
                        "You do not have any configuration templates for this make. Please set this up with the relevant Fibre Network Operator."
                    );
                }
            } else {
                if (this.device) {
                    let selectedTemplates = [];
                    if (this.device.deviceMakeModel.oneDevicePolicy && this.device.deviceMakeModel.twoDevicePolicy) {
                        selectedTemplates = this.bridgeTemplates.filter((x) => x.type == "OneDevice" || x.type == "TwoDevice");
                    } else if (this.device.deviceMakeModel.oneDevicePolicy && !this.device.deviceMakeModel.twoDevicePolicy) {
                        selectedTemplates = this.bridgeTemplates.filter((x) => x.type == "OneDevice");
                    } else if (!this.device.deviceMakeModel.oneDevicePolicy && this.device.deviceMakeModel.twoDevicePolicy) {
                        selectedTemplates = this.bridgeTemplates.filter((x) => x.type == "TwoDevice");
                    }
                    if (selectedTemplates.length == 0) {
                        confirm(
                            "You do not have any configuration templates that match the available policies for this device model. Please contact the Fibre Network Operator to rectify this issue."
                        );
                    } else {
                        if (selectedTemplates.length > 0) {
                            this.configurationSettings = {
                                type: "Multiple",
                                bridgeTemplates: selectedTemplates,
                                selectedTemplateId: selectedTemplates[0].id,
                                connectionType: selectedTemplates[0].connectionType,
                            };
                            if (selectedTemplates.length > 1 || this.configurationSettings.connectionType.toLowerCase() == "pppoe") {
                                this.configModal = true;
                            } else {
                                this.submitConfiguration();
                            }
                        }
                    }
                }
            }
        },
        generatePassword() {
            let result = "";
            let characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
            var charactersLength = characters.length;
            for (var i = 0; i < 12; i++) {
                result += characters.charAt(Math.floor(Math.random() * charactersLength));
            }
            return result;
        },
        async submitConfiguration() {
            if (
                this.configurationSettings.connectionType.toLowerCase() == "pppoe" &&
                !this.configurationSettings.pppoePassword
            ) {
                this.configurationSettings.pppoePassword = this.generatePassword();
            }
            this.provisionTemplate = this.configurationSettings.bridgeTemplates.find(
                (x) => x.id == this.configurationSettings.selectedTemplateId
            );
            this.applicationInfo.pppoeUsername = this.configurationSettings.pppoeUsername;
            this.applicationInfo.pppoePassword = this.configurationSettings.pppoePassword;

            await Api()
                .put("/customer/applications/" + this.$route.params.applicationId, {
                    ispVerified: true,
                    ispVerifiedById: this.$store.state.user.id,
                    ispVerifiedDate: new Date(),
                    ispAccepted: true,
                    organisationBridgeTemplateId: this.configurationSettings.selectedTemplateId,
                    serviceAccountType: this.configurationSettings.connectionType,
                    pppoeUsername: this.configurationSettings.pppoeUsername,
                    pppoePassword: this.configurationSettings.pppoePassword,
                })
                .then(async (response) => {
                    if (this.datatillIntegration) {
                        if (this.existingDatatillCustomer === true) {
                            Api().put("/customer/applications/" + this.$route.params.applicationId, {
                                datatillCustomerId: this.selectedExistingCustomer.customerId,
                            });
                        } else {
                            if (this.createNewDatatillCustomer) {
                                await Api()
                                    .post("/datatill/addCustomer", {
                                        organisationId: this.$store.state.currentOrg.org.id,
                                        idNumber: this.newCustomer.idNumber,
                                        name: this.newCustomer.fullName,
                                        telephoneNumber: this.newCustomer.telephoneNumber,
                                        mobileNumber: this.newCustomer.mobileNumber,
                                        emailAddress: this.newCustomer.emailAddress,
                                        physicalAddress: this.applicationInfo.location.locationDescription,
                                        postalAddress: this.applicationInfo.location.locationDescription,
                                    })
                                    .then(async (response) => {
                                        await Api().put("/customer/applications/" + this.$route.params.applicationId, {
                                            datatillCustomerId: response.data.customerId,
                                        });
                                    });
                            } else {
                                await Api().put("/customer/applications/" + this.$route.params.applicationId, {
                                    datatillCustomerId: this.applicationInfo.datatillCustomerId,
                                });
                            }
                        }
                    }
                });
            this.configModal = false;
            (this.applicationInfo.ispVerified = true),
            (this.applicationInfo.ispAccepted = true),
            (this.applicationInfo.ispVerifiedDate = new Date()),
            (this.applicationInfo.ispVerifiedById = this.$store.state.user.id),
            (this.applicationInfo.ispVerifiedBy = this.$store.state.user);

            // await this.getApplication()
            this.approveApplication();
        },
        getlocationTypes() {
            Api()
                .get("/locationTypes")
                .then((response) => {
                    this.locationTypes = response.data;
                });
        },
        fetchUserRoles() {
            Api()
                .get("/userRole")
                .then((response) => {
                    this.userRoles = response.data;
                });
        },

        fetchLocationNetworks() {
            Api()
                .get("/locationnetworks/basic/active")
                .then((response) => {
                    this.locationNetworks = response.data;
                });
        },

        fetchDeviceBridges(id) {
            Api()
                .get("/deviceBridge/" + id)
                .then((response) => {
                    this.deviceBridges = response.data;
                });
        },
        fetchTicketCategories() {
            Api()
                .get("/ticketCategory")
                .then((response) => {
                    this.ticketCategories = response.data;
                });
        },
        fetchTicketCategoryItems() {
            Api()
                .get("/ticketCategoryItem")
                .then((response) => {
                    this.ticketCategoryItems = response.data;
                    this.ticketKey += 1;
                });
        },
        addCommentEditedTicket(comment) {
            Api()
                .post("/ticketComment", {
                    ticketId: this.ticketItem.id,
                    type: "comment",
                    commentedById: this.$store.state.user.id,
                    comment: comment,
                })
                .then((response) => {
                    response.data.commentedBy = this.$store.state.user;
                    this.ticketCommentLog.push(response.data);
                    this.comment = "";
                    this.addCommentBox = false;
                });
        },
        async addApplicationComment(comment) {
            this.emailAddressArray = [];
            this.mentioned = this.members.filter((x) => comment.includes(x));
            await this.mentioned.map((y) => {
                this.membersEmail.map((x) => {
                    if (x.fullName === y) {
                        this.emailAddressArray.push(x.email);
                    }
                });
            });
            comment = comment.replace(/<div>/g, "");
            comment = comment.replace("</div>", "");
            comment = comment.replace(/<br>/g, "");
            Api()
                .post("/applicationComment", {
                    emailAddressArray: this.emailAddressArray,
                    isInternal: this.internal,
                    organisation: this.$store.state.currentOrg.org,
                    applicationId: parseInt(this.$route.params.applicationId),
                    type: "comment",
                    commentedById: this.$store.state.user.id,
                    comment: comment,
                })
                .then((response) => {
                    if (this.internal == false) {
                        this.notifyIsp();
                        this.notifyFno();
                    } else {
                        this.notifyFno();
                    }
                    this.fetchApplicationComments();
                    this.comment = "";
                });
        },
        async fetchTickets() {
            await Api()
                .get("/ticket/byApplication/" + this.$route.params.applicationId)
                .then((response) => {
                    this.tickets = response.data;
                    let temp = response.data;
                    this.ticketCarousalArray = temp.slice(0, 1);
                    this.ticketKey += 1;
                });
        },
        checkDenyPermissions() {
            if (this.authUpdate(this.$store.state.currentRoute)) {
                this.deniedReasonModal = true;
            }
        },
        provisionAccount() {
            // return true;
            if (
        this.provisionTemplate != null &&
        this.device &&
        this.device.deviceMakeModel.deviceMake.name.toLowerCase() == "zhone" &&
        this.deviceBridges.length > 0 &&
        this.deviceBridges
          .map((x) => x.tpIndex)
          .includes(
            parseInt(this.applicationInfo.organisationBridgeTemplate.tpIndex)
          )
      ) {
        return false;
      } else {
        return true;
      }

        },
        attachExisting(id) {
            Api()
                .put("customer/applications/" + this.$route.params.applicationId, {
                    locationId: id,
                })
                .then((response) => {
                    this.attachLocationModal = false;
                    this.getApplication();
                });
        },
        createNewLocation() {
            Api()
                .get("/locationNetworks/" + this.applicationInfo.locationNetworkId)
                .then((response) => {
                    Api()
                        .post("/locations", {
                            locationDescription: this.applicationInfo.streetNumber + " " + this.applicationInfo.streetName + ", " + response.data.name,
                            unitNo: this.applicationInfo.streetNumber,
                            complexStreetName: this.applicationInfo.streetName,
                            locationNetworkId: this.applicationInfo.locationNetworkId,

                            locationTypeId: this.applicationInfo.locationTypeId,
                            erfNo: this.applicationInfo.erfNo,
                            otherNo: this.applicationInfo.otherNo,
                            locationNetworkSubComplexId: this.applicationInfo.locationNetworkSubComplexId,
                            floorNo: this.applicationInfo.floorNo,
                            subComplexName: this.applicationInfo.subComplexName,
                            complexName: this.applicationInfo.complexName,
                            coordinates: this.applicationInfo.coordinates ? JSON.stringify(this.applicationInfo.coordinates) : null,
                        })
                        .then((response) => {
                            Api()
                                .put("customer/applications/" + this.$route.params.applicationId, {
                                    locationId: response.data.id,
                                })
                                .then((response) => {
                                    this.getApplication();
                                    this.attachLocationModal = false;
                                });
                        });
                });
        },

        verifyInstallation() {
            if (this.authUpdate(this.$store.state.currentRoute)) {
                this.verifyingInstallation = true;
                Api()
                    .put("/applications/" + this.$route.params.applicationId, {
                        isInstallVerified: true,
                        installVerifiedById: this.$store.state.user.id,
                        installVerifiedDate: new Date(),
                        isDeviceVerified: true,
                        deviceVerifiedById: this.$store.state.user.id,
                        deviceVerifiedDate: new Date(),
                    })
                    .then((response) => {
                        this.verifyingInstallation = false;
                        this.applicationInfo.isInstallVerified = true;
                        this.verifyingDevice = false;
                        this.applicationInfo.isDeviceVerified = true;
                        // this.notifyIsp();
                    });
            }
        },
        // verifyDevice() {
        //     if (this.authUpdate(this.$store.state.currentRoute)) {
        //         this.verifyingDevice = true;
        //         Api()
        //             .put("/applications/" + this.$route.params.applicationId, {
        //                 isDeviceVerified: true,
        //                 deviceVerifiedById: this.$store.state.user.id,
        //                 deviceVerifiedDate: new Date(),
        //             })
        //             .then((response) => {
        //                 this.verifyingDevice = false;
        //                 this.applicationInfo.isDeviceVerified = true;
        //             });
        //     }
        // },

        verifyPackage() {
            if (this.authUpdate(this.$store.state.currentRoute)) {
                Api()
                    .put("/applications/" + this.$route.params.applicationId, {
                        isPackageVerified: true,
                        packageVerifiedById: this.$store.state.user.id,
                        packageVerifiedDate: new Date(),
                    })
                    .then((response) => {
                        this.applicationInfo.isPackageVerified = true;
                        this.notifyIsp();
                    });
            }
        },
        editContact(contactType) {
            if (this.authUpdate(this.$store.state.currentRoute)) {
                if (contactType === "Primary") {
                    this.editedContact.contactType = "Primary";
                    this.editedContact.name = this.applicationInfo.primaryContactFirstname;
                    this.editedContact.surname = this.applicationInfo.primaryContactLastname;
                    this.editedContact.idNumber = this.applicationInfo.primaryContactIdNumber;
                    this.editedContact.emailAddress = this.applicationInfo.primaryContactEmailAddress;
                    this.editedContact.mobileNumber = this.applicationInfo.primaryContactMobileNumber;
                }
                if (contactType === "Secondary") {
                    this.editedContact.contactType = "Secondary";
                    this.editedContact.name = this.applicationInfo.secondaryContactFirstname;
                    this.editedContact.surname = this.applicationInfo.secondaryContactLastname;
                    this.editedContact.idNumber = this.applicationInfo.secondaryContactIdNumber;
                    this.editedContact.emailAddress = this.applicationInfo.secondaryContactEmailAddress;
                    this.editedContact.mobileNumber = this.applicationInfo.secondaryContactMobileNumber;
                }
                if (contactType === "Billing") {
                    this.editedContact.contactType = "Billing";
                    this.editedContact.name = this.applicationInfo.billingContactFirstname;
                    this.editedContact.surname = this.applicationInfo.billingContactLastname;
                    this.editedContact.idNumber = this.applicationInfo.billingContactIdNumber;
                    this.editedContact.emailAddress = this.applicationInfo.billingContactEmailAddress;
                    this.editedContact.mobileNumber = this.applicationInfo.billingContactMobileNumber;
                }
                this.editContactModal = true;
            }
        },
        saveEditedContact() {
            if (this.authUpdate(this.$store.state.currentRoute)) {
                if (this.editedContact.contactType === "Primary") {
                    Api()
                        .put("/applications/" + this.$route.params.applicationId, {
                            primaryContactFirstname: this.editedContact.name,
                            primaryContactLastname: this.editedContact.surname,
                            primaryContactMobileNumber: this.editedContact.mobileNumber,
                            primaryContactEmailAddress: this.editedContact.emailAddress,
                            primaryContactIdNumber: this.editedContact.idNumber,
                        })
                        .then((response) => {
                            this.initialize();
                            this.editContactModal = false;
                            this.editedContact = {};
                        });
                }
                if (this.editedContact.contactType === "Secondary") {
                    Api()
                        .put("/applications/" + this.$route.params.applicationId, {
                            secondaryContactFirstname: this.editedContact.name,
                            secondaryContactLastname: this.editedContact.surname,
                            secondaryContactMobileNumber: this.editedContact.mobileNumber,
                            secondaryContactEmailAddress: this.editedContact.emailAddress,
                            secondaryContactIdNumber: this.editedContact.idNumber,
                        })
                        .then((response) => {
                            this.editContactModal = false;
                            this.editedContact = {};
                            this.initialize();
                        });
                }
                if (this.editedContact.contactType === "Billing") {
                    Api()
                        .put("/applications/" + this.$route.params.applicationId, {
                            billingContactFirstname: this.editedContact.name,
                            billingContactLastname: this.editedContact.surname,
                            billingContactMobileNumber: this.editedContact.mobileNumber,
                            billingContactEmailAddress: this.editedContact.emailAddress,
                            billingContactIdNumber: this.editedContact.idNumber,
                        })
                        .then((response) => {
                            this.editContactModal = false;
                            this.editedContact = {};
                            this.initialize();
                        });
                }
            }
        },
        async goToLocation() {
            this.$router.push({
                path: "/locationNetworks/" +
                    this.applicationInfo.location.locationNetworkId +
                    "/" +
                    this.applicationInfo.locationId,
            });
        },
        async goToDevice(id) {
            let route = await this.$store.state.currentOrg.org.permissions.filter(function (el) {
                return el.url === "/devices/:deviceId";
            });

            await this.$store.dispatch("setCurrentRoute", route[0]);
            this.$router.push({
                path: "/devices/" + id,
            });
        },
        redirectToServiceAccount(id) {
            this.$router.push({
                path: "/serviceAccounts/" + id,
            });
        },
        onChange(e) {
            var files = e.target.files || e.dataTransfer.files;
            if (!files.length) {
                this.dragging = false;
                return;
            }
            this.createFile(files[0]);
        },
        async createFile(file) {
            if (file.size > 5000000) {
                alert('please check file size no over 5 MB.')
                this.dragging = false;
                return;
            }

            this.file = file;
            var reader = new FileReader();
            await reader.readAsBinaryString(this.file);
            reader.onload = () => {
                file = btoa(reader.result)
                this.file.base64 = file;
                console.log(this.file)
                this.uploadDocument(this.file)
            }

            this.dragging = false;
        },
        uploadDocument(file) {
            this.file = {
                applicationId: this.applicationInfo.id,
                name: file.name,
                base64: file.base64,
                type: file.type,
                isActive: true,
                isDeleted: false,
            }
            Api()
                .post('/upload', this.file).then(async response => {
                    this.file.id = response.data.id
                    this.file.createdAt = response.data.createdAt
                    this.documents.push(this.file)
                })
        },
        removeFile() {
            this.file = '';
        },
        addContact(contactType) {
            if (this.authUpdate(this.$store.state.currentRoute)) {
                let name = null;
                let surname = null;
                let idNumber = null;
                let mobileNumber = null;
                let emailAddress = null;
                let password = "P@ssw0rd1234";
                let permissions = "End Client";
                let isActive = true;
                if (contactType === "Primary") {
                    this.creatingPrimaryContact = true;
                    name = this.applicationInfo.primaryContactFirstname;
                    surname = this.applicationInfo.primaryContactLastname;
                    idNumber = this.applicationInfo.primaryContactIdNumber;
                    emailAddress = this.applicationInfo.primaryContactEmailAddress;
                    mobileNumber = this.applicationInfo.primaryContactMobileNumber;
                }
                if (contactType === "Secondary") {
                    this.creatingSecondaryContact = true;
                    name = this.applicationInfo.secondaryContactFirstname;
                    surname = this.applicationInfo.secondaryContactLastname;
                    idNumber = this.applicationInfo.secondaryContactIdNumber;
                    emailAddress = this.applicationInfo.secondaryContactEmailAddress;
                    mobileNumber = this.applicationInfo.secondaryContactMobileNumber;
                }
                if (contactType === "Billing") {
                    this.creatingBillingContact = true;
                    name = this.applicationInfo.billingContactFirstname;
                    surname = this.applicationInfo.billingContactLastname;
                    idNumber = this.applicationInfo.billingContactIdNumber;
                    emailAddress = this.applicationInfo.billingContactEmailAddress;
                    mobileNumber = this.applicationInfo.billingContactMobileNumber;
                }
                Api()
                    .post("/contacts", {
                        name: name,
                        surname: surname,
                        idNumber: idNumber,
                        mobileNumber: mobileNumber,
                        emailAddress: emailAddress,
                        password: password,
                        permissions: permissions,
                        isActive: isActive,
                    })
                    .then((response) => {
                        if (contactType === "Primary") {
                            this.creatingPrimaryContact = false;
                            this.applicationInfo.primaryContact = response.data;
                            Api()
                                .put("/applications/" + this.applicationInfo.id, {
                                    primaryContactId: response.data.id,
                                })
                                .then((this.applicationInfo.primaryContactId = response.data.id));
                        } else if (contactType === "Secondary") {
                            this.creatingSecondaryContact = false;
                            this.applicationInfo.secondaryContact = response.data;
                            Api()
                                .put("/applications/" + this.applicationInfo.id, {
                                    secondaryContactId: response.data.id,
                                })
                                .then((this.applicationInfo.secondaryContactId = response.data.id));
                        } else if (contactType === "Billing") {
                            this.creatingBillingContact = false;
                            this.applicationInfo.billingContact = response.data;
                            Api()
                                .put("/applications/" + this.applicationInfo.id, {
                                    billingContactId: response.data.id,
                                })
                                .then((this.applicationInfo.billingContactId = response.data.id));
                        }
                    });
            }
        },
        mergePrimaryContact(item) {
            if (this.authUpdate(this.$store.state.currentRoute)) {
                confirm("Are you sure you would like to update the existing contact?") &&
                    Api()
                    .put("/contacts/" + item.id, {
                        name: this.applicationInfo.primaryContactFirstname,
                        surname: this.applicationInfo.primaryContactLastname,
                        idNumber: this.applicationInfo.primaryContactIdNumber,
                        mobileNumber: this.applicationInfo.primaryContactMobileNumber,
                        emailAddress: this.applicationInfo.primaryContactEmailAddress,
                    })
                    .then((response) => {
                        Api()
                            .put("/applications/" + this.applicationInfo.id, {
                                primaryContactId: item.id,
                            })
                            .then((this.applicationInfo.primaryContactId = item.id));
                        this.verifyContact()
                    });
                this.similarContactsModalPrimary = false;
            }
        },
        mergeSecondaryContact(item) {
            if (this.authUpdate(this.$store.state.currentRoute)) {
                confirm("Are you sure you would like to update the existing contact?") &&
                    Api()
                    .put("/contacts/" + item.id, {
                        name: this.applicationInfo.secondaryContactFirstname,
                        surname: this.applicationInfo.secondaryContactLastname,
                        idNumber: this.applicationInfo.secondaryContactIdNumber,
                        mobileNumber: this.applicationInfo.secondaryContactMobileNumber,
                        emailAddress: this.applicationInfo.secondaryContactEmailAddress,
                    })
                    .then((response) => {
                        Api()
                            .put("/applications/" + this.applicationInfo.id, {
                                secondaryContactId: item.id,
                            })
                            .then((this.applicationInfo.secondaryContactId = item.id));
                    });
                this.similarContactsModalSecondary = false;
            }
        },
        mergeBillingContact(item) {
            if (this.authUpdate(this.$store.state.currentRoute)) {
                confirm("Are you sure you would like to update the existing contact?") &&
                    Api()
                    .put("/contacts/" + item.id, {
                        name: this.applicationInfo.billingContactFirstname,
                        surname: this.applicationInfo.billingContactLastname,
                        idNumber: this.applicationInfo.billingContactIdNumber,
                        mobileNumber: this.applicationInfo.billingContactMobileNumber,
                        emailAddress: this.applicationInfo.billingContactEmailAddress,
                    })
                    .then((response) => {
                        Api()
                            .put("/applications/" + this.applicationInfo.id, {
                                billingContactId: item.id,
                            })
                            .then((this.applicationInfo.billingContactId = item.id));
                    });
                this.similarContactsModalBilling = false;
            }
        },
        verifyContact() {
            if (this.authUpdate(this.$store.state.currentRoute)) {
                this.verifyingContact = true;
                Api()
                    .put("/applications/" + this.$route.params.applicationId, {
                        isContactVerified: true,
                        contactVerifiedById: this.$store.state.user.id,
                        contactVerifiedDate: new Date(),
                    })
                    .then((response) => {
                        this.applicationInfo.isContactVerified = true;
                        this.verifyingContact = false;
                        if (this.applicationInfo.packagesIsp)
                            this.notifyIsp();
                    });
            }
        },
        async createFullInstallTicket() {
            // this.addTicketModal = true
            await Api()
                .post("/ticket", {
                    applicationId: this.$route.params.applicationId,
                    locationId: this.applicationInfo.locationId,
                    currentStatus: "Pending",
                    importance: "Average",
                    description: "Full fibre & Device Installation",
                    ticketCategoryItemId: 17,
                    createdById: this.$store.state.user.id,
                })
                .then(() => {
                    this.snackbar = true;
                    this.text = "Successfully created install ticket!";
                    this.fetchTickets();
                });
        },
        async createTicket(type) {
            if (this.applicationInfo.location) {
                if (this.authCreate(this.$store.state.currentRoute)) {
                    this.ticketItem = {
                        currentStatus: 'Pending',
                        importance: 'Average',
                        dueDate: new Date(),
                        applicationId: this.applicationInfo.id,
                        locationId: this.applicationInfo.locationId,
                        location: this.applicationInfo.location,
                        shareWithIsp: this.applicationInfo.packagesIspId ? true : false,
                        customerOrganisationId: this.applicationInfo.customerOrganisationId?this.applicationInfo.customerOrganisationId:null,
                        documents: []
                    }
                    this.addTicketModal = true
                }
            } else {
                alert('Please create a location before processing this request.')
            }

        },

        createServiceAccount() {
            if (this.authUpdate(this.$store.state.currentRoute)) {
                let serviceAccountIdentifier = Math.floor(Math.random() * 1000000000000) + 1;
                let innerVlan = null;
                let outerVlan = null;
                let uniVlan = null;
                let uniSlan = null;
                if (this.provisionTemplate != null) {
                    innerVlan = this.provisionTemplate.innerVlan;
                    outerVlan = this.provisionTemplate.outerVlan;
                    uniVlan = this.provisionTemplate.uniVlan;
                    uniSlan = this.provisionTemplate.uniSlan;
                    this.provisionTemplate.downloadSpeed = this.applicationInfo.packagesIsp.packagesFno.speedProfile.downloadMbps;
                    this.provisionTemplate.uploadSpeed = this.applicationInfo.packagesIsp.packagesFno.speedProfile.uploadMbps;
                }
                let deviceId = null;
                let ponMac = null;
                if (this.device !== "" && this.device !== null && typeof this.device !== "undefined") {
                    deviceId = this.device.id;
                    ponMac = this.device.ponMac;
                }
                let fnoActivationDate = new Date(this.applicationInfo.activationDate);
                let autoProvision = false;
                let autoProvisionType = null;
                let autoConfigure = false;
                let autoConfigureType = null;
                let configurationTemplate = null;
                let radiusConfig = false;
                let radiusConfigSettings = null;
                let deviceBridgeId = this.provisionTemplate ? this.deviceBridges.find((x) => x.vlanXlate == this.provisionTemplate.outerVlan) : null;
                if (
                    this.provisionTemplate &&
                    !this.provisionTemplate.deviceBridgeId &&
                    this.device &&
                    this.device != null &&
                    this.device.Handle_ID != null &&
                    this.device.Handle_ID != 0 &&
                    !this.device.isU2000
                ) {
                    autoProvision = true;
                    // autoConfigure = true
                    autoProvisionType = "Zhone";
                    fnoActivationDate =
                        new Date(this.applicationInfo.activationDate) <= new Date() ?
                        new Date() :
                        new Date(this.applicationInfo.activationDate);

                    this.prepareZhoneTemplate();
                    // autoConfigureType = 'Zhone'
                } else if (
                    this.provisionTemplate &&
                    !this.provisionTemplate.deviceBridgeId &&
                    this.device &&
                    this.device != null &&
                    this.device.isU2000
                ) {
                    autoProvision = true;
                    autoProvisionType = "U2000";
                    fnoActivationDate =
                        new Date(this.applicationInfo.activationDate) <= new Date() ?
                        new Date() :
                        new Date(this.applicationInfo.activationDate);
                }
                let wifiArray = [];
                if (this.provisionTemplate && this.device && this.device.acsDevice && !this.secondaryDevice) {
                    autoConfigure = true;
                    autoConfigureType = "ACS";
                    configurationTemplate = {
                        enable: true,
                        dnsEnabled: true,
                        vlan: this.provisionTemplate.outerVlan ?
                            this.provisionTemplate.outerVlan : this.provisionTemplate.innerVlan,
                        port_1: this.provisionTemplate.port_1,
                        port_2: this.provisionTemplate.port_2,
                        port_3: this.provisionTemplate.port_3,
                        port_4: this.provisionTemplate.port_4,
                        connectionType: this.provisionTemplate.connectionType,
                        ssid_1: this.provisionTemplate.ssid_1,
                        ssid_2: this.provisionTemplate.ssid_2,
                        ssid_3: this.provisionTemplate.ssid_3,
                        ssid_4: this.provisionTemplate.ssid_4,
                        pppoeUsername: this.applicationInfo.pppoeUsername,
                        pppoePassword: this.applicationInfo.pppoePassword,
                        deviceId: this.device.id,
                        acsId: this.device.acsId,
                        ponMac: this.device.ponMac,
                        serviceType: "INTERNET",
                    };
                    if (
                        this.device.deviceMakeModel.isWifi &&
                        this.device.deviceMakeModel.twoGhzWifi &&
                        this.device.deviceMakeModel.isWifi &&
                        this.device.deviceMakeModel.fiveGhzWifi
                    ) {
                        wifiArray.push({
                            deviceId: this.device.id,
                            ssid: this.applicationInfo.ssidUsername + "_2.4Ghz",
                            password: this.applicationInfo.ssidPassword,
                            enable: true,
                            frequency: 2.4,
                            vlanId: this.provisionTemplate.outerVlan,
                            customerOrganisationId: this.applicationInfo.packagesIsp.customerOrganisationId,
                            organisationId: this.applicationInfo.supplierOrganisationId,
                            acsId: this.device.acsId,
                        });
                        wifiArray.push({
                            deviceId: this.device.id,
                            ssid: this.applicationInfo.ssidUsername + "_5Ghz",
                            password: this.applicationInfo.ssidPassword,
                            enable: true,
                            frequency: 5,
                            vlanId: this.provisionTemplate.outerVlan,
                            customerOrganisationId: this.applicationInfo.packagesIsp.customerOrganisationId,
                            organisationId: this.applicationInfo.supplierOrganisationId,
                            acsId: this.device.acsId,
                        });
                    } else if (this.device.deviceMakeModel.isWifi && this.device.deviceMakeModel.twoGhzWifi) {
                        wifiArray.push({
                            deviceId: this.device.id,
                            ssid: this.applicationInfo.ssidUsername + "_2.4Ghz",
                            password: this.applicationInfo.ssidPassword,
                            enable: true,
                            frequency: 2.4,
                            vlanId: this.provisionTemplate.outerVlan,
                            customerOrganisationId: this.applicationInfo.packagesIsp.customerOrganisationId,
                            organisationId: this.applicationInfo.supplierOrganisationId,
                            acsId: this.device.acsId,
                        });
                    }
                } else if (this.provisionTemplate && this.secondaryDevice) {
                    autoConfigure = true;
                    autoConfigureType = "ACS";
                    configurationTemplate = {
                        enable: true,
                        dnsEnabled: true,
                        vlan: this.provisionTemplate.outerVlan ?
                            this.provisionTemplate.outerVlan : this.provisionTemplate.innerVlan,
                        port_1: this.provisionTemplate.port_1,
                        port_2: this.provisionTemplate.port_2,
                        port_3: this.provisionTemplate.port_3,
                        port_4: this.provisionTemplate.port_4,
                        connectionType: this.provisionTemplate.connectionType,
                        ssid_1: this.provisionTemplate.ssid_1,
                        ssid_2: this.provisionTemplate.ssid_2,
                        ssid_3: this.provisionTemplate.ssid_3,
                        ssid_4: this.provisionTemplate.ssid_4,
                        pppoeUsername: this.applicationInfo.pppoeUsername,
                        pppoePassword: this.applicationInfo.pppoePassword,
                        deviceId: this.secondaryDevice.id,
                        acsId: this.secondaryDevice.acsId,
                        ponMac: this.secondaryDevice.ponMac,
                        serviceType: "INTERNET",
                    };
                    if (
                        this.secondaryDevice.deviceMakeModel.isWifi &&
                        this.secondaryDevice.deviceMakeModel.twoGhzWifi &&
                        this.secondaryDevice.deviceMakeModel.isWifi &&
                        this.secondaryDevice.deviceMakeModel.fiveGhzWifi
                    ) {
                        wifiArray.push({
                            deviceId: this.secondaryDevice.id,
                            ssid: this.applicationInfo.ssidUsername ?
                                this.applicationInfo.ssidUsername + "_2.4Ghz" : this.secondaryDevice.deviceMakeModel.name + "_2.4Ghz",
                            password: this.applicationInfo.ssidPassword ?
                                this.applicationInfo.ssidPassword : this.applicationInfo.primaryContact.mobileNumber,
                            enable: true,
                            frequency: 2.4,
                            vlanId: this.provisionTemplate.outerVlan,
                            customerOrganisationId: this.applicationInfo.packagesIsp.customerOrganisationId,
                            organisationId: this.applicationInfo.supplierOrganisationId,
                            acsId: this.secondaryDevice.acsId,
                        });
                        wifiArray.push({
                            deviceId: this.secondaryDevice.id,
                            ssid: this.applicationInfo.ssidUsername ?
                                this.applicationInfo.ssidUsername + "_5Ghz" : this.secondaryDevice.deviceMakeModel.name + "_5Ghz",
                            password: this.applicationInfo.ssidPassword ?
                                this.applicationInfo.ssidPassword : this.applicationInfo.primaryContact.mobileNumber,
                            enable: true,
                            frequency: 5,
                            vlanId: this.provisionTemplate.outerVlan,
                            customerOrganisationId: this.applicationInfo.packagesIsp.customerOrganisationId,
                            organisationId: this.applicationInfo.supplierOrganisationId,
                            acsId: this.secondaryDevice.acsId,
                        });
                    } else if (this.secondaryDevice.deviceMakeModel.isWifi && this.secondaryDevice.deviceMakeModel.twoGhzWifi) {
                        wifiArray.push({
                            deviceId: this.secondaryDevice.id,
                            ssid: this.applicationInfo.ssidUsername ?
                                this.applicationInfo.ssidUsername + "_2.4Ghz" : this.secondaryDevice.deviceMakeModel.name + "_2.4Ghz",
                            password: this.applicationInfo.ssidPassword ?
                                this.applicationInfo.ssidPassword : this.applicationInfo.primaryContact.mobileNumber,
                            enable: true,
                            frequency: 2.4,
                            vlanId: this.provisionTemplate.outerVlan,
                            customerOrganisationId: this.applicationInfo.packagesIsp.customerOrganisationId,
                            organisationId: this.applicationInfo.supplierOrganisationId,
                            acsId: this.secondaryDevice.acsId,
                        });
                    }
                } else if (this.provisionTemplate && this.provisionTemplate.type == "OneDevice") {
                    autoConfigure = true;
                }

                if (
                    this.applicationInfo.packagesIsp.customerOrganisationId &&
                    this.applicationInfo.packagesIsp.customerOrganisation.radiusIntegration
                ) {
                    radiusConfig = true;
                    radiusConfigSettings = {
                        username: this.applicationInfo.pppoeUsername,
                        password: this.applicationInfo.pppoePassword,
                        speed: this.applicationInfo.packagesIsp.packagesFno.speedProfile.downloadMbps +
                            "M/" +
                            this.applicationInfo.packagesIsp.packagesFno.speedProfile.uploadMbps +
                            "M",
                    };
                }

                this.applicationInfo.serviceAccountType =
                    this.provisionTemplate && this.provisionTemplate.type == "TwoDevice" ?
                    "Bridged" :
                    this.applicationInfo.serviceAccountType ?
                    this.applicationInfo.serviceAccountType :
                    "IPoE";
                Api()
                    .post("/serviceAccounts", {
                        autoConfigure: autoConfigure,
                        autoConfigureType: autoConfigureType,
                        autoProvision: autoProvision,
                        autoProvisionType: autoProvisionType,
                        radiusConfig: radiusConfig,
                        radiusConfigSettings: radiusConfigSettings,
                        configurationTemplate: configurationTemplate,
                        deviceBridgeId: this.provisionTemplate ? this.provisionTemplate.deviceBridgeId : null,
                        wifiProfiles: wifiArray,
                        ponMac: ponMac,
                        device: this.device,
                        serviceAccountIdentifier: serviceAccountIdentifier.toString(),
                        authenticationType: this.applicationInfo.serviceAccountType,
                        pppoeUsername: this.applicationInfo.pppoeUsername,
                        pppoePassword: this.applicationInfo.pppoePassword,
                        IPoEActive: true,
                        IPoEMacAddress: null,
                        // Jackal Creek / SkyCo: billing starts on the order's activation date, even if it has passed
                        fnoActivationDate: this.installNotRequired && this.applicationInfo.activationDate ?
                            new Date(this.applicationInfo.activationDate) :
                            new Date(this.applicationInfo.activationDate) <= new Date() ?
                            new Date() : new Date(this.applicationInfo.activationDate),
                        fnoDeactivationDate: null,
                        initialActivation: null,
                        // ispActivationDate: fnoActivationDate,
                        ispDeactivationDate: null,
                        staticIpv4: null,
                        staticIpv6: null,
                        deviceId: deviceId,
                        locationId: this.applicationInfo.locationId,
                        packagesIspId: this.applicationInfo.packagesIspId,
                        customerOrganisationId: this.applicationInfo.packagesIsp.customerOrganisationId,
                        supplierOrganisationId: this.applicationInfo.supplierOrganisationId,
                        organisationId: this.applicationInfo.organisationId,
                        innerVlan: innerVlan,
                        outerVlan: outerVlan,
                        uniVlan: uniVlan,
                        uniSlan: uniSlan,
                        isChange: false,
                        isDeleted: false,
                        isActive: true,
                        provisionTemplate: this.provisionTemplate,
                        applicationId: this.$route.params.applicationId,
                        contactId: this.applicationInfo.primaryContactId,
                        device: this.device,
                        datatillCustomerId: this.applicationInfo.datatillCustomerId ?
                            parseInt(this.applicationInfo.datatillCustomerId) : null,
                        ispRecurringPriceVatInc: this.applicationInfo.ispRecurringPriceVatInc,
                    })
                    .then(async (response) => {
                        this.applicationInfo.serviceAccountId = response.data.id;

                        if (this.applicationInfo.packagesIsp.customerOrganisation.isPrimaryOrganisation) {
                            let terms = [{
                                    name: "month-to-month",
                                    value: 1
                                },
                                {
                                    name: "6 month",
                                    value: 6
                                },
                                {
                                    name: "12 month",
                                    value: 12
                                },
                                {
                                    name: "24 month",
                                    value: 24
                                },
                            ];
                            let customerAccountObject = {
                                recurringInvoiceId: this.applicationInfo.recurringInvoiceId,
                                recurringInvoiceReference: this.applicationInfo.recurringInvoiceNumber,
                                deviceId: this.applicationInfo.secondaryDeviceId ?
                                    this.applicationInfo.secondaryDeviceId : this.device ? this.device.id : null,
                                reference: response.data.circuitNumber,
                                serviceAccountId: this.applicationInfo.serviceAccountId,
                                contactId: this.applicationInfo.primaryContactId,
                                startDate: fnoActivationDate,
                                packagesIspId: this.applicationInfo.packagesIspId,
                                supplierOrganisationId: this.applicationInfo.organisationId,
                                organisationId: this.applicationInfo.packagesIsp.customerOrganisationId,
                                accountingCustomerId: this.applicationInfo.accountingCustomerId,
                                radiusAuthentication: this.applicationInfo.serviceAccountType != "IPoE" ? "User" : "Mac",
                                username: this.applicationInfo.pppoeUsername,
                                password: this.applicationInfo.pppoePassword,
                                contractTerm: terms.find((x) => x.name == this.applicationInfo.packagesIsp.term).value,
                                isSuspended: false,
                                deviceOwnership: "Free to use",
                                debitOrderMandateSigned: false,
                                status: new Date(fnoActivationDate) <= new Date() ? "Live" : "Pending",
                            };
                            await Api().post("/customerAccount", customerAccountObject);
                        }
                        for (let i = 0; i < this.documents.length; i++) {
                            Api().put("/upload/" + this.documents[i].id, {
                                contactId: this.applicationInfo.primaryContactId,
                                serviceAccountId: this.applicationInfo.serviceAccountId,
                            });
                        }
                        if (this.applicationInfo.datatillCustomerId) {
                            Api().post("/datatill/createDataAccount", {
                                applicationId: this.$route.params.applicationId,
                            });
                        }

                        await this.fetchTickets();
                        Api()
                            .put("/applications/" + this.$route.params.applicationId, {
                                serviceAccountId: response.data.id,
                            })
                            .then((response) => {
                                this.initialize();
                            });
                    });
                this.text = "Service Account successfully created!";
                this.snackbar = true;
            }
        },
        createLocationContacts(contactId, contactTypeId) {
            Api().post("/locationContact", {
                contactId: contactId,
                locationId: this.applicationInfo.locationId,
                contactTypeId: contactTypeId,
                isActive: true,
                isDeleted: false,
            });
        },
        async approveApplication() {
            if (this.authCreate(this.$store.state.currentRoute)) {
                if (!this.provisionTemplate) {
                    this.provisionTemplate = this.applicationInfo.organisationBridgeTemplate;
                }
                let bridge = this.provisionTemplate ? this.deviceBridges.find((x) => x.vlanXlate == this.provisionTemplate.outerVlan) : null;
                if (bridge) {
                    this.provisionTemplate.deviceBridgeId = bridge.id;
                }
                if (this.provisionAccount()) {
                    if (this.applicationInfo.packagesIspId !== null && this.applicationInfo.serviceAccountId === null) {
                        confirm("Are you sure you would like to approve this application?") && this.approveApplicationProcess();
                    } else {
                        confirm("Are you sure you would like to approve this application?") && this.approveApplicationProcess();
                    }
                } else {
                    this.provisionWarningModal = true;
                }
            }
        },
        async approveApplicationProcess() {
            if (this.applicationInfo.primaryContactId) {
                await this.createLocationContacts(this.applicationInfo.primaryContactId, 2);
            }
            if (this.applicationInfo.secondaryContactId !== null) {
                await this.createLocationContacts(this.applicationInfo.secondaryContactId, 5);
            }
            if (this.applicationInfo.billingContactId !== null) {
                await this.createLocationContacts(this.applicationInfo.billingContactId, 8);
            }
            if (this.applicationInfo.packagesIspId !== null && this.applicationInfo.serviceAccountId === null) {
                await this.createServiceAccount();
            }

            Api()
                .put("/applications/" + this.$route.params.applicationId, {
                    isApproved: true,
                    approvedById: this.$store.state.user.id,
                    isResolved: true,
                    resolvedById: this.$store.state.user.id,
                    resolvedDate: new Date(),
                })
                .then((response) => {
                    this.applicationInfo.isApproved = true;
                    this.applicationInfo.isResolved = true;
                    if (this.applicationInfo.packagesIsp)
                        this.notifyIsp();
                });
        },
        rejectApplication() {
            if (this.authUpdate(this.$store.state.currentRoute)) {
                confirm("Are you sure you would like to reject this application?") &&
                    Api()
                    .put("/applications/" + this.$route.params.applicationId, {
                        isResolved: true,
                        resolvedById: this.$store.state.user.id,
                        resolvedDate: new Date(),
                        isDenied: true,
                        deniedReason: this.deniedReason,
                        deniedById: this.$store.state.user.id,
                    })
                    .then((response) => {
                        this.applicationInfo.isResolved = true;
                        this.applicationInfo.isDenied = true;
                        this.deniedReasonModal = false;
                        if (this.applicationInfo.packagesIsp)
                            this.notifyIsp();
                    });
            }
        },
        getLinkedContacts() {
            Api()
                .get("/contacts/linked", {
                    params: {
                        idNumber: this.applicationInfo.primaryContactIdNumber,
                        emailAddress: this.applicationInfo.primaryContactEmailAddress,
                        mobileNumber: this.applicationInfo.primaryContactMobileNumber,
                    },
                })
                .then((response) => {
                    this.linkedPrimaryContacts = response.data;
                });
            if (this.applicationInfo.secondaryContactFirstname !== null) {
                Api()
                    .get("/contacts/linked", {
                        params: {
                            idNumber: this.applicationInfo.secondaryContactIdNumber,
                            emailAddress: this.applicationInfo.secondaryContactEmailAddress,
                            mobileNumber: this.applicationInfo.secondaryContactMobileNumber,
                        },
                    })
                    .then((response) => {
                        this.linkedSecondaryContacts = response.data;
                    });
            }
            if (this.applicationInfo.billingContactFirstname !== null) {
                Api()
                    .get("/contacts/linked", {
                        params: {
                            idNumber: this.applicationInfo.billingContactIdNumber,
                            emailAddress: this.applicationInfo.billingContactEmailAddress,
                            mobileNumber: this.applicationInfo.billingContactMobileNumber,
                        },
                    })
                    .then((response) => {
                        this.linkedBillingContacts = response.data;
                    });
            }
        },
        async getExistingServiceAccounts() {
            this.existingServiceAccounts = [];
            await Api()
                .get("/serviceAccounts/active/byLocation/" + this.applicationInfo.locationId)
                .then((response) => {
                    this.existingServiceAccounts = response.data;
                    if (!this.existingServiceAccounts.length > 0) {
                        this.applicationInfo.isPackageVerified = true;
                    }
                });
        },
        setActivationDate(event) {
            const value = event.target.value;
            const monthStart = new Date();
            monthStart.setDate(1);
            monthStart.setHours(0, 0, 0, 0);
            if (!value || (new Date(value + "T00:00:00") < monthStart &&
                !confirm("Earlier months have already been billed, so days before the 1st of this month will not be charged. Use this date anyway?"))) {
                event.target.value = this.applicationInfo.activationDate;
                return;
            }
            this.applicationInfo.activationDate = value;
            Api().put("/applications/" + this.applicationInfo.id, { activationDate: value });
        },
        updateApplication(item){
            Api().put("/applications/" + item.id, item).then(res=>{
                this.isLoading = false
                this.editLocation = false
            })
        },
        async getApplication() {
            await Api()
                .get("/applications/supplier/" + this.$route.params.applicationId)
                .then((response) => {
                    this.applicationInfo = response.data;
                    this.secondaryDevice = this.applicationInfo.secondaryDevice;
                    this.initialAccessBuildDocument = this.applicationInfo.additionalAccessBuildDocument;
                    this.initialAccessBuildFee = this.applicationInfo.additionalAccessBuildFeeExclVat;
                    this.$router.push({
                        query: {
                            search: "",
                            offset: "0",
                            records: "10"
                        },
                    });
                    if (this.applicationInfo.locationId) {
                        this.locationContacts = [];
                        if (typeof this.applicationInfo.location.devices !== "undefined") {
                            for (let i = 0; i < this.applicationInfo.location.devices.length; i++) {
                                if (
                                    // ((this.applicationInfo.location.devices[i].deviceMakeModel.deviceType.name == "Mikrotik") || (this.applicationInfo.location.devices[i].deviceMakeModel.deviceType.name == "GPON ONU"))
                                    this.applicationInfo.location.devices[i].deviceMakeModel.deviceType.name == "GPON ONU" &&
                                    this.applicationInfo.location.devices[i].isActive
                                ) {
                                    this.device = this.applicationInfo.location.devices[i];
                                }
                            }
                        }

                        if (
                            typeof this.applicationInfo.location.locationContacts !== "undefined" &&
                            this.applicationInfo.location.locationContacts.length > 0
                        ) {
                            for (let y = 0; y < this.applicationInfo.location.locationContacts.length; y++) {
                                if (
                                    this.applicationInfo.location.locationContacts[y].isActive &&
                                    !this.applicationInfo.location.locationContacts[y].isDeleted
                                ) {
                                    this.locationContacts.push(this.applicationInfo.location.locationContacts[y]);
                                }
                            }
                        }
                    } else {
                        // this.attachLocationModal = true;
                    }
                    if (this.applicationInfo.coordinates) {
                        this.applicationInfo.coordinates = JSON.parse(this.applicationInfo.coordinates);
                    }

                    this.getLinkedContacts();
                    if (!this.applicationInfo.hasTvOverFibre && this.applicationInfo.packagesIspId === null) {
                        this.applicationInfo.isInstallVerified = true;
                        this.applicationInfo.isDeviceVerified = true;
                    }
                });
            this.pages = new Array(this.locationContacts.length);
            for (let i = 0; i < this.locationContacts.length; ++i) this.pages[i] = 0;
        },
        notifyFno() {
            Api().post("/notifications/application/notifyFno", {
                applicationId: this.$route.params.applicationId,
                organisationId: this.applicationInfo.supplierOrganisationId,
            });
        },
        notifyIsp() {
            Api().post("/notifications/application/notifyIsp", {
                applicationId: this.$route.params.applicationId,
                customerOrganisationId: this.applicationInfo.packagesIsp.customerOrganisationId,
            });
        },
    },
};
</script>

<style>
.rounded-card {
    border-radius: 30px;
}

.v-stepper__header {
    box-shadow: none;
}

.wrap-text {
    white-space: normal;
}

.list--dense.fix .list__tile__title {
    height: 20px;
}

.dropZone {
    width: 180px;
    height: 90%;
    position: relative;
    border: 2px dashed #eee;
}

.dropZone:hover {
    border: 2px solid #2e94c4;
}

.dropZone:hover .dropZone-title {
    color: #1975A0;
}

.dropZone-info {
    color: #A8A8A8;
    position: absolute;
    top: 50%;
    width: 100%;
    transform: translate(0, -50%);
    text-align: center;
}

.dropZone-title {
    color: #787878;
}

.dropZone input {
    position: absolute;
    cursor: pointer;
    top: 0px;
    right: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
}

.dropZone-upload-limit-info {
    display: flex;
    justify-content: flex-start;
    flex-direction: column;
}

.dropZone-over {
    background: #5C5C5C;
    opacity: 0.8;
}

.dropZone-uploaded {
    width: 80%;
    height: 200px;
    position: relative;
    border: 2px dashed #eee;
}

.dropZone-uploaded-info {
    display: flex;
    flex-direction: column;
    align-items: center;
    color: #A8A8A8;
    position: absolute;
    top: 50%;
    width: 100%;
    transform: translate(0, -50%);
    text-align: center;
}

.removeFile {
    width: 200px;
}
</style>
